import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  Search,
  MoreHorizontal,
  ChevronsUpDown,
  ChevronLeft,
  ChevronRight,
  X,
  Copy,
  SquareArrowOutUpRight,
  Funnel,
  Pencil,
  Info,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import { useHistory, useLocation } from "react-router-dom";
import Tooltip from "../addentities/Tooltip";
import apiHelper from "../../apiHelper";
import SearchBox from "../../components/SearchBox";
import emptySearchImg from "../../assets/img/brand/empty-search.png";
import noBrandImage from "../../assets/img/brand/no-brand-img.png";
import noImage from "../../assets/img/brand/noImage.png";
import DynamicTable from "../../components/DynamicTable";
import { useOutsideClick } from "../../components/useOutsideClick";
import { useLoader } from "../../components/GlobalLoader";
import ConfirmDeactivateModal from "../../components/ConfirmDeactivateModal";
import ConfirmArchiveModal from "../../components/ConfirmArchiveModal";
import AlertNotification from "../../components/AlertNotification";
import SkuInfoDrawer from "../../components/SkuInfoDrawer";
import Pagination from "../../components/Pagination";

const formatDateTime = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
// Drawer -> Stock instances tab data
const imeiStockData = [
  {
    id: 1,
    imei: "35334107 123456 2",
    location: "Bedok",
    available: 232,
    reserved: 2,
    pending: [
      { type: "Inbounding", color: "#198754", count: 5 },
      { type: "Outbounding", color: "#FD7E14", count: 10 },
      { type: "Transferring", color: "#6C757D", count: 9 },
    ],
  },
  {
    id: 2,
    imei: "35334107 123456 2",
    location: "(Pending)",
    available: 43,
    reserved: 2,
    pending: [
      { type: "Outbounding", color: "#FD7E14", count: 10 },
      { type: "Transferring", color: "#6C757D", count: 9 },
    ],
  },
  {
    id: 3,
    imei: "35334107 123456 2",
    location: "HQ",
    available: 67,
    reserved: 6,
    pending: [{ type: "Inbounding", color: "#198754", count: 5 }],
  },
];


const PAGE_SIZE = 20; // Display all 10 rows on one page

export default function StockList() {
  const [copied, setCopied] = useState(false);

  const [activeTab, setActiveTab] = useState("stock-list");
  const history = useHistory();
  const location = useLocation();

  // Breadcrumbs (you can adjust these if needed)
  const breadcrumbs = ["Stock", "Stock List"];

  // Search, pagination, and multi‐selection state
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  // Archived Branch Tab

  const [archivedSearchInput, setArchivedSearchInput] = useState("");
  const [archivedSearchTerm, setArchivedSearchTerm] = useState("");
  const [archivedCurrentPage, setArchivedCurrentPage] = useState(1);
  const [archivedSelectedIds, setarchivedSelectedIds] = useState([]);
  const [archivedStatusFilter, setArchivedStatusFilter] = useState("");

  // “Suppress highlight” flag: if true, even checked rows will not be highlighted
  const [suppressHighlight, setSuppressHighlight] = useState(false);

  // Single‐row Drawer state (unchanged)
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTab, setDrawerTab] = useState("entity-info");
  const [drawerTab2, setDrawerTab2] = useState("entity-info2");
  const [selectedRow, setSelectedRow] = useState(null);
  const [skuDrawerOpen, setSkuDrawerOpen] = useState(false);
  const [selectedSkuId, setSelectedSkuId] = useState(null);

  const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [archivedSortConfig, setArchivedSortConfig] = useState({
    key: "archived_time", // Default sort by Archived Time
    direction: "desc",
  });

  const [stockData, setStockData] = useState([]);
  const [archivedStockData, setArchivedStockData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterPopupOpen, setFilterPopupOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);

  const [archivedFilterPopupOpen, setArchivedFilterPopupOpen] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const [sortField, setSortField] = useState("lastModifiedTime");
  const [sortOrder, setSortOrder] = useState("desc"); // 'asc' or 'desc'

  // temp filter state (same pattern as Brand)
  const [tempConditionL1, setTempConditionL1] = useState([]);
  const [tempConditionL2, setTempConditionL2] = useState([]);
  const [tempStatuses, setTempStatuses] = useState([]);
  const [tempBrands, setTempBrands] = useState([]);
  const [tempCategories, setTempCategories] = useState([]);
  const [tempTypes, setTempTypes] = useState([]);

  // temp states
  const [archivedTempConditionL1, setArchivedTempConditionL1] = useState([]);
  const [archivedTempConditionL2, setArchivedTempConditionL2] = useState([]);
  const [archivedTempStatuses, setArchivedTempStatuses] = useState([]);
  const [archivedTempBrands, setArchivedTempBrands] = useState([]);
  const [archivedTempCategories, setArchivedTempCategories] = useState([]);
  const [archivedTempTypes, setArchivedTempTypes] = useState([]);

  // applied filters
  const [conditionL1, setConditionL1] = useState([]);
  const [conditionL2, setConditionL2] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);

  const [archivedConditionL1, setArchivedConditionL1] = useState([]);
  const [archivedConditionL2, setArchivedConditionL2] = useState([]);
  const [archivedStatuses, setArchivedStatuses] = useState([]);
  const [archivedBrands, setArchivedBrands] = useState([]);
  const [archivedCategories, setArchivedCategories] = useState([]);
  const [archivedTypes, setArchivedTypes] = useState([]);

  const [conditionL1Open, setConditionL1Open] = useState(false);
  const [conditionL2Open, setConditionL2Open] = useState(false);
  const [brandsOpen, setBrandsOpen] = useState(false);
  const [categoriesOpen, setCategoriesOpen] = useState(false);
  const [typesOpen, setTypesOpen] = useState(false);

  // archived dropdown open states
  const [archivedConditionL1Open, setArchivedConditionL1Open] = useState(false);
  const [archivedConditionL2Open, setArchivedConditionL2Open] = useState(false);
  const [archivedBrandsOpen, setArchivedBrandsOpen] = useState(false);
  const [archivedCategoriesOpen, setArchivedCategoriesOpen] = useState(false);
  const [archivedTypesOpen, setArchivedTypesOpen] = useState(false);

  const [conditionL1Search, setConditionL1Search] = useState("");
  const [statusSearch, setStatusSearch] = useState("");
  const [brandSearch, setBrandSearch] = useState("");
  const [categorySearch, setCategorySearch] = useState("");
  const [typeSearch, setTypeSearch] = useState("");

  const [conditionL2Search, setConditionL2Search] = useState("");
  const [archivedStatusSearch, setArchivedStatusSearch] = useState("");

  // archived search inputs
  const [archivedConditionL1Search, setArchivedConditionL1Search] =
    useState("");
  const [archivedConditionL2Search, setArchivedConditionL2Search] =
    useState("");
  const [archivedBrandSearch, setArchivedBrandSearch] = useState("");
  const [archivedCategorySearch, setArchivedCategorySearch] = useState("");
  const [archivedTypeSearch, setArchivedTypeSearch] = useState("");

  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [archivedDropdownOpenId, setArchivedDropdownOpenId] = useState(null);

  const [stockfilterDrawerOpen, setStockfilterDrawerOpen] = useState(false);

  // Dropdown positioning state
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [archivedDropdownPosition, setarchivedDropdownPosition] = useState({
    top: 0,
    left: 0,
  });

  const [archivedModalOpen, setArchivedModalOpen] = useState(false);

  // Drawer Dropdown latest code below
  const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
  const [toolbarDropdownOpen2, setToolbarDropdownOpen2] = useState(false);
  const [imeiSearchInput, setImeiSearchInput] = useState("");
  const [pageInView, setPageInView] = useState(1); // changed name
  const [isStockOpen, setisStockOpen] = useState(false);
  const [stockSearch, setStockSearch] = useState("");
  const [selectedStock, setSelectedStock] = useState([]);
  const [tempSelectedStock, setTempSelectedStock] = useState([]);
  const [instancesDrawerOpen, setInstancesDrawerOpen] = useState(false);
  const [stockoutModalOpen, setStockoutModalOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [imeiDropdownOpenId, setImeiDropdownOpenId] = useState(null);
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [hasAutoOpened, setHasAutoOpened] = useState(false);
  const [stockDrawerOpen, setStockDrawerOpen] = useState(false);
  const [selectedStockRow, setSelectedStockRow] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const [archiveStockDrawerOpen, setArchiveStockDrawerOpen] = useState(false);
  const [selectedArchiveStockRow, setSelectedArchiveStockRow] = useState(null);

const autoOpen = queryParams.get("autoOpen");
const stockId = queryParams.get("id");
useEffect(() => {
  if (autoOpen === "true" && stockId) {
    setSelectedRow({
      id: stockId
    });

    setDrawerOpen(true);
  }
}, [location.search]);
  const archivedFiltered = useMemo(() => {
    const keywords = (archivedSearchTerm || "").toLowerCase().split(/[,\s]+/).filter(Boolean);
    let results = archivedStockData.filter((d) => {

      if (keywords.length === 0) return true;

      const searchableWords = [ d.name, d.variant, d.id?.toString(),]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean);

      return keywords.some(word =>
        searchableWords.includes(word)
      );
    });


    // ✅ ARCHIVED FILTERS (duplicated from stock)
    if (archivedConditionL1.length) {
      results = results.filter((d) =>
        archivedConditionL1.includes(d.condition)
      );
    }

    if (archivedConditionL2.length) {
      results = results.filter((d) => archivedConditionL2.includes(d.grading));
    }

    if (archivedStatuses.length) {
      results = results.filter((d) => archivedStatuses.includes(d.status));
    }

    if (archivedBrands.length) {
      results = results.filter((d) => archivedBrands.includes(d.brand));
    }

    if (archivedCategories.length) {
      results = results.filter((d) => archivedCategories.includes(d.category));
    }

    if (archivedTypes.length) {
      results = results.filter((d) => archivedTypes.includes(d.type));
    }

    // ✅ ARCHIVED SORTING
    if (archivedSortConfig.key) {
      results = [...results].sort((a, b) => {
        const aVal = a[archivedSortConfig.key] ?? "";
        const bVal = b[archivedSortConfig.key] ?? "";

        if (aVal < bVal) return archivedSortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return archivedSortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }

    return results;
  }, [
    archivedSearchTerm,
    archivedStockData,
    archivedSortConfig,

    // ✅ archived dependencies ONLY
    archivedConditionL1,
    archivedConditionL2,
    archivedStatuses,
    archivedBrands,
    archivedCategories,
    archivedTypes,
  ]);

  const archivedPageData = archivedFiltered.slice(
    (archivedCurrentPage - 1) * PAGE_SIZE,
    archivedCurrentPage * PAGE_SIZE
  );

  const [brandsData, setBrandsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const { showLoader, hideLoader } = useLoader();

  const [deactivateModalOpen, setDeactivateModalOpen] = useState(false);
  const [selectedStockId, setSelectedStockId] = useState(null);
  const [selectedArchiveStockId, setSelectedArchiveStockId] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const NON_SORTABLE_COLUMNS = ["inStock_Sellable", "pending"];
  const [archiveFromDrawer, setArchiveFromDrawer] = useState(false);

  const [actionFromDrawer, setActionFromDrawer] = useState(false);
  const query = new URLSearchParams(location.search);
  const fromPage = location.state?.page ?? 1;

  const StockStatCell = ({ items = [] }) => {
    if (!items.length)
      return <span style={{ color: "#ADB5BD" }}>NA</span>;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        {items.map((item) => (
          <div
            key={item.type}
            style={{
              display: "grid",
              gridTemplateColumns: "100px auto", // 1st column fixed
              alignItems: "center",
              columnGap: "12px",
              fontSize: "12px",
            }}
          >
            {/* 1st Column: Dot + Type */}
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: item.color,
                }}
              />
              <span style={{ color: "#495057" }}>
                {item.type}
              </span>
            </div>

            {/* 2nd Column: Count */}
            <span
              style={{
                textAlign: "left", // left aligned
                fontWeight: 500,
                color: "#212529",
                fontVariantNumeric: "tabular-nums", // equal digit width
                fontFeatureSettings: '"tnum"',
              }}
            >
              {Number(item.count || 0).toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    );
  };
  const isStockTab = activeTab === "stock-list";
  const isArchivedTab = activeTab === "archived-stock";

  const isArchivedSearching = archivedSearchTerm?.trim().length > 0;
  //useEffect

  const [errorPopup, setErrorPopup] = useState({
    open: false,
    title: "",
    message: "",
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [conditionL1, conditionL2, statuses, brands, categories, types]);

  useEffect(() => {
    setArchivedCurrentPage(1);
  }, [archivedConditionL1, archivedConditionL2, archivedStatuses, archivedBrands, archivedCategories, archivedTypes]);

  useEffect(() => {
    const state = location.state;
    if (!state) return;

    // ✅ Restore pagination
    if (state.page && currentPage !== state.page) {
      setCurrentPage(state.page);
    }

    // WAIT until stockData is available
    if (!state.reopenDrawer || !state.stockId || stockData.length === 0) {
      return;
    }

    const row = stockData.find(
      (item) => String(item.id) === String(state.stockId)
    );

    if (!row) return;

    // ✅ Open drawer
    setSelectedRow(row);
    setSelectedSkuId(row.sku_id);
    // setSkuDrawerOpen(true);
    setDrawerOpen(true);
    setDrawerTab(state.tab || "entity-info");

    // 🔥 Clear reopen flags AFTER success
    history.replace({
      pathname: "/stock-list",
      state: {
        page: state.page,
      },
    });
  }, [location.state, stockData]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);

    const autoOpen = query.get("autoOpen") === "true";
    const from = query.get("from");
    const isArchived = query.get("archived") === "true";
    const stockId = query.get("id");
    const tab = query.get("tab");

    if (!autoOpen || !stockId || hasAutoOpened) return;

    // 🔹 Decide data source
    const sourceData = isArchived ? archivedPageData : stockData;

    if (!sourceData || sourceData.length === 0) return;

    const row = sourceData.find((r) => String(r.id) === String(stockId));

    if (!row) return;

    // 🔹 Switch tab if archived
    if (isArchived) {
      setActiveTab("archived-stock"); // 🔥 adjust to your actual archived tab key
    }

    setSelectedRow(row);
    setDrawerOpen(true);
    setDrawerTab(tab || "entity-info");
    setHasAutoOpened(true);

    // 🔥 IMPORTANT: clear URL to prevent re-open loop
    history.replace(location.pathname);
  }, [location.search, stockData, archivedPageData, hasAutoOpened]);

  useEffect(() => {
    if (!filterPopupOpen) {
      closeAllDropdowns();
    }
  }, [filterPopupOpen]);

  useEffect(() => {
    if (!archivedFilterPopupOpen) {
      closeAllArchivedDropdowns();
    }
  }, [archivedFilterPopupOpen]);

  useEffect(() => {
    async function fetchStockInstances() {
      setLoading(true);
      setError(null);
      showLoader();
      const startTime = performance.now();
      try {
        const response = await apiHelper(
          "inventory/stocks/?archived=false",
          "GET"
        );
        const apiTime = performance.now();
        console.log(
          `⏱ API Response Time: ${(apiTime - startTime).toFixed(2)} ms`
        );
        const apiData = await response.json();
        const jsonTime = performance.now();
        console.log(
          `⏱ JSON Parse Time: ${(jsonTime - apiTime).toFixed(2)} ms`
        );
        console.log("API Response:", apiData);
        const mapStart = performance.now();

        const mapApiStockToUi = (item) => {
          const summary = item.stock_status_summary; // <-- REQUIRED

          return {
            id: item.stock_id,
            is_archived: item.is_archived,
            archived_time: formatDateTime(item.archived_at),
            archived_at: formatDateTime(item.archived_at),

            // SPU & SKU
            name: item.spu_name,
            variant: item.sku_name,
            avatar: item.image ? item.image : noImage,
            sku_code: item.sku_code,
            openId: item.sku_uuid,
            sku_notes: item.sku_notes,

            // Conditions
            condition: item.condition || "NA",
            grading: item.condition_type || "NA",

            // Status
            status: item.status ? "Active" : "Inactive",

            // Meta
            brand: item.brand,
            // category: item.category,
            category: item.category_hierarchy ? item.category_hierarchy.map((c) => c.name).join(' >> ') : '',
            type: item.product_type || "NA",

            // Dates
            lastModifiedTime: formatDateTime(item.modified_at),
            createdAt: formatDateTime(item.created_at),
            createdBy: item.created_by_name,
            modifiedBy: item.modified_by_name,
            archivedBy: item.archived_by_name,

            spu_id: item.spu_id,
            sku_id: item.sku_id,

            // UPDATED: Real backend values with FE colors
            pending: [
              {
                type: "Inbounding",
                color: "#198754",
                count:
                  summary.pending?.find((s) => s.type === "Inbounding")?.count ??
                  0,
              },
              {
                type: "Distributing",
                color: "#FD7E14",
                count:
                  summary.pending?.find((s) => s.type === "Distributing")?.count ??
                  0,
              },
              {
                type: "Transferring",
                color: "#2C7BE5",
                count:
                  summary.pending?.find((s) => s.type === "Transferring")?.count ??
                  0,
              },
              {
                type: "Outbounding",
                color: "#DC3545",
                count:
                  summary.pending?.find((s) => s.type === "Outbounding")?.count ??
                  0,
              },  
            ],

            inStock_Sellable: [
              {
                type: "In Stock",
                color: "#198754",
                count: (summary.inStock_Sellable.find((s) => s.type === "Sellable")
                  ?.count ?? 0) + summary.reserved,
                // summary.inStock_Sellable.find((s) => s.type === "In Stock")
                //   ?.count ?? 0,
              },
              {
                type: "Sellable",
                color: "#FD7E14",
                count:
                  summary.inStock_Sellable.find((s) => s.type === "Sellable")
                    ?.count ?? 0,
              },
            ],

            reserved: summary.reserved, // if you need reserved directly
          };
        };

        if (Array.isArray(apiData)) {
          const mapped = apiData.map(mapApiStockToUi);
          setStockData(mapped);
        } else {
          setStockData([]);
        }
        const mapEnd = performance.now();
        console.log(
          `⏱ Mapping Time: ${(mapEnd - mapStart).toFixed(2)} ms`
        );
        console.log(
          `🔥 TOTAL FRONTEND TIME: ${(mapEnd - startTime).toFixed(2)} ms`
        );

      } catch (err) {
        // setStockData(dummyData);
        setError("Failed to load stock instances");
      } finally {
        setLoading(false);
        hideLoader();
      }
    }

    fetchStockInstances();
  }, []);


  const fetchArchivedStockInstances = async () => {
    try {
      const response = await apiHelper(
        "inventory/stocks/?archived=true",
        "GET"
      );
      const apiData = await response.json();

      const mapApiStockToUi = (item) => ({
        id: item.stock_id,
        is_archived: item.is_archived,
        archived_time: formatDateTime(item.archived_at),
        name: item.spu_name,
        variant: item.sku_name,
        avatar: item.image ? item.image : noImage,
        sku_code: item.sku_code,
        openId: item.sku_uuid,
        sku_notes: item.sku_notes,

        condition: item.condition || "NA",
        grading: item.condition_type || "NA",
        status: item.status ? "Active" : "Inactive",

        brand: item.brand,
        // category: item.category,
        category: item.category_hierarchy ? item.category_hierarchy.map((c) => c.name).join(' >> ') : '',
        type: item.product_type || "NA",

        lastModifiedTime: formatDateTime(item.modified_at),
        createdAt: formatDateTime(item.created_at),
        createdBy: item.created_by_name,
        modifiedBy: item.modified_by_name,
        archivedBy: item.archived_by_name,

        spu_id: item.spu_id,
        sku_id: item.sku_id,

        pending: [],
        inStock_Sellable: [],
      });

      setArchivedStockData(
        Array.isArray(apiData) ? apiData.map(mapApiStockToUi) : []
      );
    } catch (err) {
      console.error("Archived API error", err);
    }
  };

  useEffect(() => {
    const loadArchivedStocks = async () => {
      await fetchArchivedStockInstances();
    };

    loadArchivedStocks();
  }, []);

  useEffect(() => {
    async function fetchBrands() {
      try {
        const res = await apiHelper(
          "inventory/brands/?is_archived=false",
          "GET"
        );

        const data = await res.json();
        const mapped = data.map((item) => ({
          id: item.brand_id,
          name: item.brand_name,
          image: item.original_logo || noImage,
          status: item.status ? "Active" : "Inactive",
        }));

        setBrandsData(mapped);
      } catch (e) {
        console.error("Brand API failed", e);
      }
    }

    fetchBrands();
  }, []);

  useEffect(() => {
    async function fetchCategories() {
      try {
        const res = await apiHelper(
          "inventory/categories/?is_archived=false",
          "GET"
        );

        const data = await res.json();

        const mapped = data.map((item) => ({
          id: item.category_id,
          name: item.category_name,
          parent_name: item.parent_name,
          parent_parent_name: item.parent_parent_name,
          parent_category: item.parent_category,
        }));

        setCategoriesData(mapped);
      } catch (e) {
        console.error("Category API failed", e);
      }
    }

    fetchCategories();
  }, []);


  useEffect(() => {
    if (filterPopupOpen && filterButtonRef.current) {
      const rect = filterButtonRef.current.getBoundingClientRect();
      setFilterPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [filterPopupOpen]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        filterPopupRef.current &&
        !filterPopupRef.current.contains(e.target) &&
        filterButtonRef.current &&
        !filterButtonRef.current.contains(e.target)
      ) {
        setFilterPopupOpen(false);
      }
    }

    if (filterPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterPopupOpen]);


  useEffect(() => {
    function handleClickOutsideDrawer(event) {
      // Block during SKU drawer closing transition
      if (window.__blockDrawerClose) return;

      // Main drawer not open → nothing to do
      if (!drawerOpen) return;

      // If SKU drawer open → DO NOT close main drawer
      if (skuDrawerOpen) return;

      // Modals take priority
      if (archivedModalOpen || deactivateModalOpen) return;

      const target = event.target;

      // If click inside main drawer → ignore
      if (drawerRef.current?.contains(target)) return;

      // If click inside filter drawer → ignore
      if (filterDrawerRef.current?.contains(target)) return;

      // Otherwise close main drawer
      setDrawerOpen(false);
      setSelectedRow(null);
    }

    document.addEventListener("mousedown", handleClickOutsideDrawer);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDrawer);
    };
  }, [drawerOpen, skuDrawerOpen, archivedModalOpen, deactivateModalOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !archivedButtonRefs.current[archivedDropdownOpenId]?.contains(
          event.target
        )
      ) {
        setArchivedDropdownOpenId(null);
      }
    }

    if (archivedDropdownOpenId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [archivedDropdownOpenId]);

  useEffect(() => {
    function handleClickOutsideFilter(e) {
      if (!stockfilterDrawerOpen) return;
      // if click inside filter drawer, keep it open
      if (filterDrawerRef.current && filterDrawerRef.current.contains(e.target))
        return;
      // if click is inside main drawer and you prefer NOT to close filter when user clicks main drawer, return
      if (drawerRef.current && drawerRef.current.contains(e.target)) {
        // decide: either close filter when clicking main drawer or keep it open.
        // I will close the filter when clicking main by default — change to `return;` if you want to keep it open.
        // return;
      }
      // otherwise close filter
      closeAllDropdowns();
      setStockfilterDrawerOpen(false);
    }

    document.addEventListener("mousedown", handleClickOutsideFilter);
    return () =>
      document.removeEventListener("mousedown", handleClickOutsideFilter);
  }, [stockfilterDrawerOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRefs.current[dropdownOpenId]?.contains(event.target)
      ) {
        setDropdownOpenId(null);
      }
    }

    if (dropdownOpenId !== null) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpenId]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (archivedRef.current && !archivedRef.current.contains(event.target)) {
        setArchivedModalOpen(false);
      }
    }

    if (archivedModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [archivedModalOpen]);

  useEffect(() => {
    setFilterCount(selectedStatuses.length);
  }, [selectedStatuses]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (toolbarRef.current && !toolbarRef.current.contains(e.target)) {
        setToolbarDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        filterPopupRef.current &&
        !filterPopupRef.current.contains(e.target) &&
        filterButtonRef.current &&
        !filterButtonRef.current.contains(e.target)
      ) {
        setFilterPopupOpen(false);
      }
    };

    if (filterPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterPopupOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (stockoutRef.current && !stockoutRef.current.contains(event.target)) {
        setStockoutModalOpen(false);
      }
    }

    if (stockoutModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [stockoutModalOpen]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tableRef.current && !tableRef.current.contains(e.target)) {
        setImeiDropdownOpenId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isStockOpen &&
        stockRef.current &&
        !stockRef.current.contains(e.target)
      ) {
        setisStockOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isStockOpen]);

  useEffect(() => {
    if (stockfilterDrawerOpen) {
      setStockSearch(""); // Clear previous search
    }
  }, [stockfilterDrawerOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (saveRef.current && !saveRef.current.contains(event.target)) {
        setSaveModalOpen(false);
      }
    }

    if (saveModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [saveModalOpen]);

  useEffect(() => {
    const el = drawerContainerRef.current;
    if (!el) return;
    if (stockfilterDrawerOpen) el.classList.add("filter-open");
    else el.classList.remove("filter-open");

    return () => el && el.classList.remove("filter-open");
  }, [stockfilterDrawerOpen]);

  //useMemo
  const conditionL1Options = useMemo(() => {
    return [
      ...new Set(
        stockData.map((item) => item.condition).filter((v) => v && v !== "NA")
      ),
    ];
  }, [stockData]);


  const filteredConditionL1 = conditionL1Options;
  const archivedFilteredConditionL1 = conditionL1Options;

  const conditionL2Options = useMemo(() => {
    return [
      ...new Set(
        stockData
          .map((item) => item.grading)
          .filter((v) => v && v !== "NA") // exclude NA
      ),
    ];
  }, [stockData]);

  const filteredConditionL2 = conditionL2Options;
  const archivedFilteredConditionL2 = conditionL2Options;


  const brandOptions = useMemo(() => {
    return brandsData.filter((b) => b.name && b.status === "Active").sort((a, b) => a.name.localeCompare(b.name));
  }, [brandsData]);

  const filteredBrands = useMemo(() => {
    return brandOptions.filter((b) =>
      b.name.toLowerCase().includes(brandSearch.toLowerCase())
    );
  }, [brandOptions, brandSearch]);

  const archivedFilteredBrands = useMemo(() => {
    return brandOptions.filter((b) =>
      b.name.toLowerCase().includes(archivedBrandSearch.toLowerCase())
    );
  }, [brandOptions, archivedBrandSearch]);
  const categoryOptions = useMemo(() => {
    return categoriesData.filter((c) => c.name).sort((a, b) => a.name.localeCompare(b.name));
  }, [categoriesData]);


  const filteredCategories = useMemo(() => {
    const search = categorySearch.toLowerCase();

    return categoryOptions.filter(
      (c) =>
        (c.name && c.name.toLowerCase().includes(search)) ||
        (c.parent_name && c.parent_name.toLowerCase().includes(search))
    );
  }, [categoryOptions, categorySearch]);

  const archivedFilteredCategories = useMemo(() => {
    const search = archivedCategorySearch.toLowerCase();

    return categoryOptions.filter(
      (c) =>
        (c.name && c.name.toLowerCase().includes(search)) ||
        (c.parent_name && c.parent_name.toLowerCase().includes(search))
    );
  }, [categoryOptions, archivedCategorySearch]);

  const typeOptions = ["Accessory","Device", "Spare Parts", "Others"];
  const filteredTypes = typeOptions;
  const archivedFilteredTypes = typeOptions;

  const filtered = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    let results = stockData.filter((d) => {
      if (!term) return true;

      return (
        d.name?.toLowerCase().includes(term) ||
        d.variant?.toLowerCase().includes(term) ||
        d.id?.toString().includes(term)
      );
    });

    // ✅ APPLY FILTERS (from Apply button)
    if (conditionL1.length) {
      results = results.filter((d) => conditionL1.includes(d.condition));
    }

    if (conditionL2.length) {
      results = results.filter((d) => conditionL2.includes(d.grading));
    }

    if (statuses.length) {
      results = results.filter((d) => statuses.includes(d.status));
    }

    if (brands.length) {
      results = results.filter((d) => brands.includes(d.brand));
    }

    if (categories.length) {
      results = results.filter((d) => categories.includes(d.category));
    }

    if (types.length) {
      results = results.filter((d) => types.includes(d.type));
    }

    // ✅ Sorting (unchanged)
    if (sortConfig.key) {
      results = [...results].sort((a, b) => {
        const aVal = a[sortConfig.key] ?? "";
        const bVal = b[sortConfig.key] ?? "";

        if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
        if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }

    return results;
  }, [
    searchTerm,
    stockData,
    sortConfig,
    conditionL1,
    conditionL2,
    statuses,
    brands,
    categories,
    types,
  ]);

  const sortedFiltered = useMemo(() => {
    if (!sortField) return filtered;

    return [...filtered].sort((a, b) => {
      const aVal = a[sortField] ?? "";
      const bVal = b[sortField] ?? "";

      if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }, [filtered, sortField, sortOrder]);

  // 1. Filtered & visible rows based on selected branch and global search
  const visibleImeiRows = useMemo(() => {
    let rows = imeiStockData;

    // Filter by selected branch
    if (selectedStock.length > 0) {
      const selectedBranchNames = selectedStock.map((b) => b.value);
      rows = rows.filter((row) => selectedBranchNames.includes(row.location));
    }

    // Filter by search text
    if (imeiSearchInput.trim()) {
      const searchLower = imeiSearchInput.toLowerCase();
      rows = rows.filter((row) =>
        Object.values(row).some((val) =>
          String(val).toLowerCase().includes(searchLower)
        )
      );
    }

    return rows;
  }, [imeiStockData, imeiSearchInput, selectedStock]);

  // 2. Stats (calculated based on visible filtered rows)
  const imeiStats = useMemo(() => {
    let reserved = 0;
    let available = 0;
    const pendingTotals = {};

    visibleImeiRows.forEach((row) => {
      reserved += row.reserved || 0;
      available += row.available || 0;

      if (Array.isArray(row.pending)) {
        row.pending.forEach((p) => {
          if (!pendingTotals[p.type]) {
            pendingTotals[p.type] = { count: 0, color: p.color };
          }
          pendingTotals[p.type].count += p.count || 0;
        });
      }
    });

    return { reserved, available, pendingTotals };
  }, [visibleImeiRows]);

  const allStock = useMemo(() => {
    const uniqueBranches = [
      ...new Set(imeiStockData.map((item) => item.location)),
    ];
    return uniqueBranches.map((b) => ({ label: b, value: b }));
  }, [imeiStockData]);

  // useRef
  const filterPopupRef = useRef(null);
  const filterButtonRef = useRef(null);
  const archivedFilterButtonRef = useRef(null);
  const archivedFilterPopupRef = useRef(null);
  const conditionL1Ref = useRef(null);
  const conditionL2Ref = useRef(null);
  const brandRef = useRef(null);
  const categoryRef = useRef(null);
  const typeRef = useRef(null);
  const archivedConditionL1Ref = useRef(null);
  const archivedConditionL2Ref = useRef(null);
  const archivedBrandRef = useRef(null);
  const archivedCategoryRef = useRef(null);
  const archivedTypeRef = useRef(null);
  const dropdownRef = useRef(null);
  const buttonRefs = useRef({});
  const archivedButtonRefs = useRef({});
  const drawerRef = useRef(null);
  const archivedRef = useRef(null);
  const toolbarRef = useRef(null);
  const stockRef = useRef(null);
  const stockoutRef = useRef(null);
  const tableRef = useRef();
  const imeiDropdownRef = useRef(null);
  const imeiButtonRefs = useRef({});
  const saveRef = useRef(null);
  const drawerContainerRef = useRef(null);
  const filterDrawerRef = useRef(null);

  // useOutsideClick
  useOutsideClick(conditionL1Ref, conditionL1Open, () => {
    setConditionL1Open(false);
    setConditionL1Search("");
  });

  useOutsideClick(conditionL2Ref, conditionL2Open, () => {
    setConditionL2Open(false);
    setConditionL2Search("");
  });

  useOutsideClick(brandRef, brandsOpen, () => {
    setBrandsOpen(false);
    setBrandSearch("");
  });

  useOutsideClick(categoryRef, categoriesOpen, () => {
    setCategoriesOpen(false);
    setCategorySearch("");
  });

  useOutsideClick(typeRef, typesOpen, () => {
    setTypesOpen(false);
    setTypeSearch("");
  });

  useOutsideClick(archivedConditionL1Ref, archivedConditionL1Open, () => {
    setArchivedConditionL1Open(false);
    setArchivedConditionL1Search("");
  });
  useOutsideClick(archivedConditionL2Ref, archivedConditionL2Open, () => {
    setArchivedConditionL2Open(false);
    setArchivedConditionL2Search("");
  });

  useOutsideClick(archivedBrandRef, archivedBrandsOpen, () => {
    setArchivedBrandsOpen(false);
    setArchivedBrandSearch("");
  });

  useOutsideClick(archivedCategoryRef, archivedCategoriesOpen, () => {
    setArchivedCategoriesOpen(false);
    setArchivedCategorySearch("");
  });

  useOutsideClick(archivedTypeRef, archivedTypesOpen, () => {
    setArchivedTypesOpen(false);
    setArchivedTypeSearch("");
  });
  const isSearching = searchTerm?.trim().length > 0;

  const isFilterApplied =
    conditionL1.length > 0 ||
    conditionL2.length > 0 ||
    statuses.length > 0 ||
    brands.length > 0 ||
    categories.length > 0 ||
    types.length > 0;

  const archivedFiltersApplied =
    archivedConditionL1.length > 0 ||
    archivedConditionL2.length > 0 ||
    archivedStatuses.length > 0 ||
    archivedBrands.length > 0 ||
    archivedCategories.length > 0 ||
    archivedTypes.length > 0;

  const emptyImage =
    (isStockTab && (isSearching || isFilterApplied)) ||
      (isArchivedTab && (isArchivedSearching || archivedFiltersApplied))
      ? emptySearchImg
      : noBrandImage;

  const emptyTitle =
    isSearching || isFilterApplied || archivedFiltersApplied
      ? "No Stock Found"
      : "No Stock Found";

  const emptyMessage =
    isSearching || isArchivedSearching
      ? "No results match what you’re looking for"
      : isFilterApplied || archivedFiltersApplied
        ? "No results match your filters"
        : "Nothing here yet. Add your first item to get started!";

  const toggleConditionL1Dropdown = (e) => {
    e.stopPropagation();
    setConditionL1Open((prev) => !prev);
  };

  const toggleConditionL2Dropdown = (e) => {
    e.stopPropagation();
    setConditionL2Open((prev) => !prev);
  };

  const toggleBrandDropdown = (e) => {
    e.stopPropagation();
    setBrandsOpen((prev) => {
      if (!prev) setBrandSearch("");
      return !prev;
    });
  };

  const toggleCategoryDropdown = (e) => {
    e.stopPropagation();
    setCategoriesOpen((prev) => !prev);
  };

  const toggleTypeDropdown = (e) => {
    e.stopPropagation();
    setTypesOpen((prev) => !prev);
  };

  const toggleArchivedConditionL1Dropdown = (e) => {
    e.stopPropagation();
    setArchivedConditionL1Open((prev) => !prev);
  };

  const toggleArchivedConditionL2Dropdown = (e) => {
    e.stopPropagation();
    setArchivedConditionL2Open((prev) => !prev);
  };

  const toggleArchivedStatuses = (value) => {
    setArchivedTempStatuses((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleArchivedBrandDropdown = (e) => {
    e.stopPropagation();
    setArchivedBrandsOpen((prev) => !prev);
  };

  const closeAllDropdowns = () => {
    setConditionL1Open(false);
    setConditionL1Search("");

    setConditionL2Open(false);
    setConditionL2Search("");

    setBrandsOpen(false);
    setBrandSearch("");

    setCategoriesOpen(false);
    setCategorySearch("");

    setTypesOpen(false);
    setTypeSearch("");
  };

  const closeAllArchivedDropdowns = () => {
    setArchivedConditionL1Open(false);
    setArchivedConditionL1Search("");

    setArchivedConditionL2Open(false);
    setArchivedConditionL2Search("");

    setArchivedBrandsOpen(false);
    setArchivedBrandSearch("");

    setArchivedCategoriesOpen(false);
    setArchivedCategorySearch("");

    setArchivedTypesOpen(false);
    setArchivedTypeSearch("");
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);

    // auto-hide after 2s
    setTimeout(() => setCopied(false), 2000);
  };

  const toggleArchivedConditionL2 = (value) => {
    setArchivedTempConditionL2((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleArchivedBrands = (value) => {
    setArchivedTempBrands((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleArchivedCategories = (value) => {
    setArchivedTempCategories((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleArchivedTypes = (value) => {
    setArchivedTempTypes((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const handleDeactivateStock = async (stockId) => {
    if (!stockId) return;

    try {
      const response = await apiHelper(
        `inventory/stocks/${stockId}/deactivate/`,
        "POST"
      );

      const data = await response.json();

      if (!response.ok) {
        setErrorPopup({
          open: true,
          title: data.title || "Action not allowed",
          message: data.message || "Unable to update stock status",
        });
        return;
      }

      const isActive = data.status;

      setSuccessMessage(data.detail || "Status updated successfully.");

      // ✅ Update table row
      setStockData((prev) =>
        prev.map((item) =>
          item.id === stockId
            ? { ...item, status: isActive ? "Active" : "Inactive" }
            : item
        )
      );

      // ✅ Update drawer row if open
      setSelectedRow((prev) =>
        prev && prev.id === stockId
          ? { ...prev, status: isActive ? "Active" : "Inactive" }
          : prev
      );

      setDeactivateModalOpen(false);
      setSelectedStockId(null);

      // 🔥 IMPORTANT: only close drawer if NOT from drawer
      if (!actionFromDrawer && !isActive) {
        setDrawerOpen(false);
        setSelectedRow(null);
      }

      setActionFromDrawer(false);
    } catch (err) {
      setErrorPopup({
        open: true,
        title: "Something went wrong",
        message: "Please try again later.",
      });
    }
  };

  const handleArchiveStock = async (stockId) => {
    if (!stockId) return;

    try {
      const response = await apiHelper(
        `inventory/stocks/${stockId}/archive/`,
        "POST"
      );

      const data = await response.json();

      // ❌ BLOCKED
      if (!response.ok) {
        setArchivedModalOpen(false);
        setErrorPopup({
          open: true,
          title: data.title || "Action not allowed",
          message: data.message || "Unable to archive this stock",
        });
        return;
      }

      // ✅ SUCCESS
      setSuccessMessage(data.detail || "Stock archived successfully");

      setStockData((prev) => prev.filter((item) => item.id !== stockId));
      await fetchArchivedStockInstances();

      setArchivedModalOpen(false);
      setSelectedArchiveStockId(null);

      // 🔥 ONLY close drawer if NOT triggered from drawer
      if (!actionFromDrawer) {
        setDrawerOpen(false);
        setSelectedRow(null);
      }

      setActionFromDrawer(false);
    } catch (err) {
      setErrorPopup({
        open: true,
        title: "Something went wrong",
        message: "Please try again later.",
      });
    }
  };

  const handleSort = (field) => {
    setSortField((prevField) => {
      if (prevField === field) {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
        return prevField;
      } else {
        setSortOrder("asc");
        return field;
      }
    });
  };

  const handleArchivedSort = (key) => {
    setArchivedSortConfig((prev) => {
      if (prev.key === key) {
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const pageData = sortedFiltered.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

  const activeRow =
    dropdownOpenId !== null
      ? pageData.find((d) => d.id === dropdownOpenId)
      : null;


  const isinitialTableEmpty = pageData.length === 0;
  const isTableEmpty = stockData.length === 0;
  const isArchivedTableEmpty = archivedStockData.length === 0;
  const archivedTotalPages = Math.ceil(archivedFiltered.length / PAGE_SIZE);

  //mine //

  const columns = [
    {
      field: "name",
      label: "SPU & SKU",
      sortable: true,
      width: "200px", // use px to match td width
      render: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            minWidth: "150px", // force min width to match th
            overflow: "hidden", // prevent breaking
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <img
            src={row.avatar}
            alt="avatar"
            style={{ width: 28, height: 28, borderRadius: 4 }}
          />
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <div>{row.name}</div>
            <div className="sub-line">{row.variant}</div>
          </div>
        </div>
      ),
    },
    {
      field: "condition",
      label: "Condition L1",
      sortable: true,
      width: "113px",
      render: (row) => (
        <span
          className="highlight no-ellipsis"
          style={{ minWidth: "100px", display: "inline-block" }}
        >
          {row.condition}
        </span>
      ),
    },
    {
      field: "grading",
      label: "Condition L2",
      sortable: true,
      width: "116px",
      render: (row) => (
        <span
          className="highlight no-ellipsis"
          style={{ minWidth: "100px", display: "inline-block" }}
        >
          {row.grading}
        </span>
      ),
    },
    {
      field: "status",
      label: "Status",
      sortable: true,
      width: "120px",
      render: (row) => (
        <span
          className="highlight no-ellipsis"
          style={{ minWidth: "100px", display: "inline-block" }}
        >
          {row.status}
        </span>
      ),
    },
    {
      field: "brand",
      label: "Brand",
      sortable: true,
      width: "80px",
    },
    {
      field: "category",
      label: "Category",
      sortable: true,
      width: "120px",
    },
    {
      field: "type",
      label: "Type",
      sortable: true,
      width: "130px",
      render: (row) => (
        <span
          className="highlight no-ellipsis"
          style={{ minWidth: "120px", display: "inline-block" }}
        >
          {row.type}
        </span>
      ),
    },
    {
      field: "inStock_Sellable", // FIXED: Match the field name in data
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "4px", fontWeight: 700 }}>
          In Stock & Sellable <Tooltip title="In Stock & Sellable" body={
            <>
              <b style={{ fontWeight: 800 }}>In Stock:</b> the Qty of items which are already in a specific Branch under the current StockInstance
              <br />
              <b style={{ fontWeight: 800 }}>Sellable:</b> the Qty of items which are already in a specific Branch and also not be reserved under the current StockInstance
            </>
          } >
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <g clipPath="url(#clip0_3856_30308)">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375   
                                        6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594   
                                        6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594   
                                        2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688   
                                        8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322   
                                        7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784   
                                        6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0   
                                        3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z"
                  fill="#5E6E82"
                />
                <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969   
                                      4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094   
                                      4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934   
                                      7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559   
                                      7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875   
                                      5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375   
                                      5 3.4375Z" fill="#5E6E82" />
              </g>
              <defs>
                <clipPath id="clip0_3856_30308">
                  <rect width="10" height="10" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Tooltip>
        </span>
      ),
      width: "170px",
      sortable: true,
      render: (row) => <StockStatCell items={row.inStock_Sellable} />,
    },
    {
      field: "pending",
      label: "Pending",
      sortable: true,
      width: "190px",
      thProps: { "data-key": "pending" },
      render: (row) => <StockStatCell items={row.pending} />,
    },
    {
      field: "id",
      label: "ID",
      sortable: true,
      width: "60px",
    },
    {
      field: "lastModifiedTime",
      label: "Last Modified Time",
      sortable: true,
      width: "160px",
    },
  ];

  const archivedColumns = [
    {
      field: "name",
      label: "SPU & SKU",
      sortable: true,
      width: "200px", // use px to match td width
      render: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            minWidth: "150px", // force min width to match th
            overflow: "hidden", // prevent breaking
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <img
            src={row.avatar}
            alt="avatar"
            style={{ width: 28, height: 28, borderRadius: 4 }}
          />
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            <div>{row.name}</div>
            <div className="sub-line">{row.variant}</div>
          </div>
        </div>
      ),
    },
    {
      field: "condition",
      label: "Condition L1",
      sortable: true,
      width: "113px",
      render: (row) => (
        <span
          className="highlight no-ellipsis"
          style={{ minWidth: "100px", display: "inline-block" }}
        >
          {row.condition}
        </span>
      ),
    },
    {
      field: "grading",
      label: "Condition L2",
      sortable: true,
      width: "116px",
      render: (row) => (
        <span
          className="highlight no-ellipsis"
          style={{ minWidth: "100px", display: "inline-block" }}
        >
          {row.grading}
        </span>
      ),
    },
    {
      field: "brand",
      label: "Brand",
      sortable: true,
      width: "80px",
    },
    {
      field: "category",
      label: "Category",
      sortable: true,
      width: "120px",
    },
    {
      field: "type",
      label: "Type",
      sortable: true,
      width: "130px",
      render: (row) => (
        <span
          className="highlight no-ellipsis"
          style={{ minWidth: "120px", display: "inline-block" }}
        >
          {row.type}
        </span>
      ),
    },

    {
      field: "id",
      label: "ID",
      sortable: true,
      width: "60px",
    },
    {
      field: "archived_time",
      label: "Archived Time",
      sortable: true,
      width: "160px",
    },
  ];

  const handleCloseFilterPopup = () => {
    setSelectedStatuses([]);
    setFilterPopupOpen(false);
  };

  const handleArchivedCloseFilterPopup = () => {
    setSelectedStatuses([]);
    setArchivedFilterPopupOpen(false);
  };

  const handleCheckboxChange = (setter, value) => (e) => {
    const checked = e.target.checked;
    setter((prev) =>
      checked ? [...prev, value] : prev.filter((v) => v !== value)
    );
  };

  const toggleConditionL1 = (value) => {
    setTempConditionL1((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleArchivedConditionL1 = (item) => {
    setArchivedTempConditionL1((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleConditionL2 = (value) => {
    setTempConditionL2((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleBrands = (value) => {
    setTempBrands((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleCategories = (value) => {
    setTempCategories((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const toggleTypes = (value) => {
    setTempTypes((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const handleApplyFilters = () => {
    setConditionL1(tempConditionL1);
    setConditionL2(tempConditionL2);
    setStatuses(tempStatuses);
    setBrands(tempBrands);
    setCategories(tempCategories);
    setTypes(tempTypes);

    setBrandSearch("");
    setCategorySearch("");

    // update filter count badge
    const total =
      tempConditionL1.length +
      tempConditionL2.length +
      tempStatuses.length +
      tempBrands.length +
      tempCategories.length +
      tempTypes.length;

    setFilterCount(total);

    setFilterPopupOpen(false);
  };

  const handleClearFilters = () => {
    // clear temp states
    setTempConditionL1([]);
    setTempConditionL2([]);
    setTempStatuses([]);
    setTempBrands([]);
    setTempCategories([]);
    setTempTypes([]);

    // clear applied states
    setConditionL1([]);
    setConditionL2([]);
    setStatuses([]);
    setBrands([]);
    setCategories([]);
    setTypes([]);
    setBrandSearch("");
    setCategorySearch("");
    setFilterCount(0);
  };

  const handleCloseArchivedFilterPopup = () => {
    setArchivedFilterPopupOpen(false);
  };

  const handleApplyArchivedFilters = () => {
    setArchivedConditionL1(archivedTempConditionL1);
    setArchivedConditionL2(archivedTempConditionL2);
    setArchivedStatuses(archivedTempStatuses);
    setArchivedBrands(archivedTempBrands);
    setArchivedCategories(archivedTempCategories);
    setArchivedTypes(archivedTempTypes);
    setArchivedFilterPopupOpen(false);
  };

  const handleClearArchivedFilters = () => {
    setArchivedTempConditionL1([]);
    setArchivedTempConditionL2([]);
    setArchivedTempStatuses([]);
    setArchivedTempBrands([]);
    setArchivedTempCategories([]);
    setArchivedTempTypes([]);

    setArchivedConditionL1([]);
    setArchivedConditionL2([]);
    setArchivedStatuses([]);
    setArchivedBrands([]);
    setArchivedCategories([]);
    setArchivedTypes([]);
  };

  //mine//
  const FilterActiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333"
        stroke="#0D6EFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_4516_4830)">
        <path
          d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z"
          fill="#0D6EFD"
        />
      </g>
      <defs>
        <clipPath id="clip0_4516_4830">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(11 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const FilterInactiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333"
        stroke="#6C757D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445"
        stroke="#6C757D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  const filtersApplied = selectedStatuses.length > 0;

  // Toggle selecting a single row (checkbox)
  const toggleSelect = (id) => {
    setSelectedIds((ids) => {
      const newIds = ids.includes(id)
        ? ids.filter((x) => x !== id)
        : [...ids, id];

      // As soon as user toggles a checkbox, we should no longer suppress highlight
      setSuppressHighlight(false);
      return newIds;
    });
  };

  // Toggle “select all” on the current page
  const toggleAll = () => {
    setSelectedIds((prev) => {
      const next =
        prev.length === pageData.length ? [] : pageData.map((d) => d.id);

      // As soon as user toggles “select all,” remove the suppression
      setSuppressHighlight(false);
      return next;
    });
  };

  // When a row (except its checkbox) is clicked, open the single‐row drawer
  const onRowClick = (row) => {
    setSelectedRow(row);
    setDrawerTab("entity-info");
    setDrawerTab2("entity-info2");
    setDrawerOpen(true);
  };

  // Toggle the per‐row dropdown menu
  const toggleDropdown = (id) => {
    if (dropdownOpenId === id) {
      setDropdownOpenId(null);
    } else {
      const btn = buttonRefs.current[id];
      if (btn) {
        const rect = btn.getBoundingClientRect();
        const dropdownWidth = 150;
        const dropdownHeight = 100;

        let left = rect.left + window.scrollX - dropdownWidth + rect.width;
        if (left < window.scrollX + 8) {
          left = window.scrollX + 8;
        }

        let top = rect.bottom + window.scrollY;
        if (top + dropdownHeight > window.scrollY + window.innerHeight) {
          top = rect.top + window.scrollY - dropdownHeight;
        }

        setDropdownPosition({ top, left });
      }
      setDropdownOpenId(id);
    }
  };

  const toggleArchivedDropdown = (id) => {
    if (archivedDropdownOpenId === id) {
      setArchivedDropdownOpenId(null);
    } else {
      const btn = archivedButtonRefs.current[id];
      if (btn) {
        const rect = btn.getBoundingClientRect();
        const dropdownWidth = 150;
        const dropdownHeight = 100;

        let left = rect.left + window.scrollX - dropdownWidth + rect.width;
        if (left < window.scrollX + 8) left = window.scrollX + 8;

        let top = rect.bottom + window.scrollY;
        if (top + dropdownHeight > window.scrollY + window.innerHeight) {
          top = rect.top + window.scrollY - dropdownHeight;
        }

        setarchivedDropdownPosition({ top, left });
      }
      setArchivedDropdownOpenId(id);
    }
  };

  const handleArchivedConfirm = () => {
    setArchivedModalOpen(false);
  };

  const toggleToolbarDropdown = () => {
    setToolbarDropdownOpen((prev) => !prev);
  };
  const toggleToolbarDropdown2 = () => {
    setToolbarDropdownOpen2((prev) => !prev);
  };

  // Stock Out modal code

  const handleStockoutConfirm = () => {
    setStockoutModalOpen(false);
  };

  const handleIncrease = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleDecrease = () => {
    if (quantity > 1) setQuantity((prev) => prev - 1);
  };

  // Toggle dropdown open/closed
  const toggleStock = () => {
    setisStockOpen((prev) => !prev);
  };


  // Filtered list based on search text
  const filteredStock = allStock.filter((d) =>
    d.label.toLowerCase().includes(stockSearch.trim().toLowerCase())
  );

  // Add/remove stocks from selectedStock
  const handleStockCheckbox = (stocks) => {
    const exists = selectedStock.findIndex(
      (item) => item.value === stocks.value
    );
    if (exists > -1) {
      // Remove if already selected
      setSelectedStock((prev) =>
        prev.filter((item) => item.value !== stocks.value)
      );
    } else {
      // Otherwise, add
      setSelectedStock((prev) => [...prev, stocks]);
    }
  };

  // Remove a tag when “×” is clicked
  const removeStock = (valueToRemove) => {
    setSelectedStock((prev) =>
      prev.filter((item) => item.value !== valueToRemove)
    );
  };

  const handleTempStockCheckbox = (stock) => {
    setTempSelectedStock((prev) => {
      const exists = prev.find((item) => item.value === stock.value);
      if (exists) {
        return prev.filter((item) => item.value !== stock.value);
      } else {
        return [...prev, stock];
      }
    });
  };

  const handleSaveConfirm = () => {
    setSaveModalOpen(false);
  };

  const toggleTempStatus = (status) => {
    setTempStatuses((prev) =>
      prev.includes(status)
        ? prev.filter((s) => s !== status)
        : [...prev, status]
    );
  };

  return (
    <div className="company-body new-look stock-wrap">
      {/* Breadcrumbs */}
      <div className="breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <span key={index} className="breadcrumb-item">
            {crumb}
            {index !== breadcrumbs.length - 1}
          </span>
        ))}
      </div>

      <div className="employee-tabs-container">
        {/* ─── Tab Buttons ─── */}
        <div className="tabs">
          <button
            // Apply the "active" class only when this tab is selected
            className={`tab ${activeTab === "stock-list" ? "active" : ""}`}
            onClick={() => setActiveTab("stock-list")}
          >
            Stocks
          </button>

          <button
            className={`tab ${activeTab === "archived-stock" ? "active" : ""}`}
            onClick={() => setActiveTab("archived-stock")}
          >
            Archived Stocks
          </button>
        </div>

        {/* ─── Tab Contents ─── */}
        {activeTab === "stock-list" && (
          <div className="tab-content" id="stock-list-content">
            {/* Stock List Card */}
            <div className="info-section">
              <div className="info-card">
                <div className="entities-tab">
                  <div className="toolbar">
                    <div className="toolbar-left">
                      <SearchBox
                        searchInput={searchInput}
                        setSearchInput={setSearchInput}
                        setSearchTerm={setSearchTerm}
                        setCurrentPage={setCurrentPage}
                        disabled={isTableEmpty}
                      />
                      <button
                        ref={filterButtonRef}
                        className={`icon-btn p-2 filter-btn ${isFilterApplied ? "applied" : ""
                          }`}
                        onClick={() =>
                          !isTableEmpty && setFilterPopupOpen((prev) => !prev)
                        } 
                        disabled={isTableEmpty} // ← NEW
                        style={{
                          border: isFilterApplied
                            ? "1px solid #2C7BE5"
                            : "1px solid #6C757D",
                          borderWidth: "1px",
                          color: isFilterApplied ? "#2C7BE5" : "#6C757D",
                          background: isTableEmpty
                            ? "#E9ECEF" // ← background when empty
                            : isFilterApplied
                              ? "#CFE2FF"
                              : "#FFFFFF",

                          height: "40px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: isTableEmpty ? 0.6 : 1,
                          pointerEvents: isTableEmpty ? "none" : "auto",
                        }}
                      >
                        {isFilterApplied ? (
                          <FilterActiveIcon />
                        ) : (
                          <FilterInactiveIcon />
                        )}
                      </button>
                    </div>
                  </div>

                  {filterPopupOpen && (
                    <>
                      {/* Overlay */}
                      <div
                        onClick={handleCloseFilterPopup}
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100vh",
                          backgroundColor: "rgba(0,0,0,0.4)",
                          zIndex: 1500,
                        }}
                      />

                      {/* Drawer */}
                      <div
                        ref={filterPopupRef}
                        style={{
                          position: "fixed",
                          top: 0,
                          right: 0,
                          width: 360,
                          height: "100vh",
                          backgroundColor: "#FFFFFF",
                          boxShadow: "-3px 0 12px rgba(0,0,0,0.1)",
                          zIndex: 2000,
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden", // 🔥 important
                        }}
                      >
                        {/* ================= HEADER ================= */}
                        <div
                          style={{
                            height: 60,
                            padding: "15px 20px",
                            background: "#F8F9FA",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #E9ECEF",
                          }}
                        >
                          <h4
                            style={{
                              margin: 0,
                              fontWeight: 600,
                              color: "#212529",
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                            }}
                          >
                            Filter
                          </h4>

                          <button
                            onClick={handleCloseFilterPopup}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              padding: 4,
                            }}
                          >
                            <X size={18} />
                          </button>
                        </div>

                        {/* ================= BODY (SCROLLABLE) ================= */}
                        <div
                          style={{
                            flex: 1,
                            overflowY: "auto",
                            paddingBottom: 16,
                          }}
                        >
                          {/* Condition L1 */}
                          <div
                            className="position-relative"
                            ref={conditionL1Ref}
                            style={{ padding: "5px 19px 0 19px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontStyle: "normal",
                                lineHeight: "normal",
                              }}
                            >
                              Condition L1
                            </label>

                            {/* Input + Tags */}
                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setConditionL1Open(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {/* Selected tags */}
                              {tempConditionL1.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontSize:12,
                                    fontWeight: 600
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleConditionL1(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {tempConditionL1.length === 0 && (
                                <span
                                  style={{
                                    color: "#6C757D",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat",
                                    userSelect: "none",
                                  }}
                                >
                                  Select...
                                </span>
                              )}

                              {/* Dropdown icon */}
                              <span
                                onClick={toggleConditionL1Dropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {conditionL1Open ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {/* Dropdown */}
                            {conditionL1Open && (
                              <div
                                className="dropdown-menu show"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {filteredConditionL1.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {filteredConditionL1.map((item) => {
                                  const isSelected =
                                    tempConditionL1.includes(item);

                                  return (
                                    <div
                                      key={item}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() => toggleConditionL1(item)}
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529',
                                        fontSize: 14
                                      }}
                                    >
                                      <span>{item}</span>

                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* Condition L2 */}
                          <div
                            className="position-relative"
                            ref={conditionL2Ref}
                            style={{ padding: "5px 19px 0 19px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontStyle: "normal",
                                lineHeight: "normal",
                              }}
                            >
                              Condition L2
                            </label>

                            {/* Input + Tags */}
                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setConditionL2Open(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {/* Selected tags */}
                              {tempConditionL2.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontFamily: "Montserrat",
                                    fontSize:12,
                                    fontWeight: 600
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleConditionL2(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {tempConditionL2.length === 0 && (
                                <span
                                  style={{
                                    color: "#6C757D",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat",
                                    userSelect: "none",
                                  }}
                                >
                                  Select...
                                </span>
                              )}

                              {/* Dropdown icon */}
                              <span
                                onClick={toggleConditionL2Dropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {conditionL2Open ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {/* Dropdown */}
                            {conditionL2Open && (
                              <div
                                className="dropdown-menu show mt-1"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {filteredConditionL2.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {filteredConditionL2.map((item) => {
                                  const isSelected =
                                    tempConditionL2.includes(item);

                                  return (
                                    <div
                                      key={item}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() => toggleConditionL2(item)}
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529',
                                        fontSize: 14
                                      }}
                                    >
                                      <span>{item}</span>

                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* Status */}
                          <div
                            style={{
                              padding: "5px 20px 0 20px",
                            }}
                          >
                            {/* Status Filter */}
                            <div>
                              <label
                                style={{
                                  fontWeight: 600,
                                  marginBottom: "8px",
                                  color: "#212529",
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  lineHeight: "normal",
                                }}
                              >
                                Status
                              </label>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {["Active", "Inactive"].map((status) => (
                                  <label
                                    key={status}
                                    className="form-check"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      cursor: "pointer",
                                      // paddingLeft: 0,
                                      padding: "10px",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={tempStatuses.includes(status)} // ✅ temp state
                                      onChange={() => toggleTempStatus(status)} // ✅ temp handler
                                      style={{
                                        position: "absolute",
                                        opacity: 0,
                                        width: 0,
                                        height: 0,
                                      }}
                                    />
                                    <span
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        border: tempStatuses.includes(status)
                                          ? "1.5px solid #212529"
                                          : "1px solid #212529",
                                        borderRadius: "4px",
                                        backgroundColor: tempStatuses.includes(
                                          status
                                        )
                                          ? "#FFEB00"
                                          : "white",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        transition: "all 0.2s ease",
                                        position: "relative",
                                        flexShrink: 0,
                                      }}
                                    >
                                      {tempStatuses.includes(status) && (
                                        <svg
                                          width="12"
                                          height="12"
                                          viewBox="0 0 12 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          style={{ position: "absolute" }}
                                        >
                                          <path
                                            d="M2 6L4.5 8.5L10 3"
                                            stroke="#000"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </span>

                                    <span
                                      style={{
                                        fontFamily: "Montserrat",
                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        lineHeight: "18px",
                                        color: "#212529",
                                      }}
                                    >
                                      {status}
                                    </span>
                                  </label>
                                ))}
                              </div>
                            </div>
                          </div>

                          {/* Brand */}
                          <div
                            ref={brandRef}
                            className="position-relative"
                            style={{ padding: "5px 20px 0 20px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontStyle: "normal",
                                lineHeight: "normal",
                              }}
                            >
                              Brand
                            </label>

                            {/* Input + Tags */}
                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setBrandsOpen(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {tempBrands.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleBrands(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {/* Search input */}
                              <input
                                type="text"
                                value={brandSearch}
                                onChange={(e) => {
                                  setBrandSearch(e.target.value);
                                  setBrandsOpen(true);
                                }}
                                placeholder={
                                  tempBrands.length === 0
                                    ? "Select or Search..."
                                    : ""
                                }
                                style={{
                                  border: "none",
                                  outline: "none",
                                  flex: 1,
                                  minWidth: 60,
                                  background: "transparent",
                                  fontSize:14,
                                  fontWeight:400,
                                  color:'#6C757D'
                                }}
                              />

                              {/* Dropdown icon */}
                              <span
                                onClick={toggleBrandDropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {brandsOpen ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {/* Dropdown */}
                            {brandsOpen && (
                              <div
                                className="dropdown-menu show mt-1"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {filteredBrands.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {filteredBrands.map((item) => {
                                  const isSelected = tempBrands.includes(
                                    item.name
                                  );

                                  return (
                                    <div
                                      key={item.id}
                                      className="dropdown-item d-flex align-items-center justify-content-between"
                                      onClick={() => {
                                        toggleBrands(item.name);
                                        setBrandSearch("");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        padding: "8px 12px",
                                      }}
                                    >
                                      {/* left side: image + name */}
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 8,
                                        }}
                                      >
                                        <img
                                          src={item.image}
                                          alt={item.name}
                                          style={{
                                            width: 30,
                                            height: 30,
                                            objectFit: "contain",
                                            borderRadius: 4,
                                            background: "#fff",
                                            flexShrink: 0,
                                          }}
                                          onError={(e) => {
                                            e.target.src =
                                              "/images/brand-placeholder.png";
                                          }}
                                        />

                                        <span
                                          style={{
                                            fontFamily: "Montserrat",
                                            fontSize: "14px",
                                            color: "#212529",
                                          }}
                                        >
                                          {item.name}
                                        </span>
                                      </div>

                                      {/* right side: check */}
                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* Category */}
                          <div
                            ref={categoryRef}
                            className="position-relative"
                            style={{ padding: "5px 20px 0 20px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                              }}
                            >
                              Category
                            </label>

                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setCategoriesOpen(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {tempCategories.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleCategories(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              <input
                                type="text"
                                value={categorySearch}
                                onChange={(e) => {
                                  setCategorySearch(e.target.value);
                                  setCategoriesOpen(true);
                                }}
                                placeholder={
                                  tempCategories.length === 0
                                    ? "Select or Search..."
                                    : ""
                                }
                                style={{
                                  border: "none",
                                  outline: "none",
                                  flex: 1,
                                  minWidth: 60,
                                  background: "transparent",
                                  fontSize:14,
                                  fontWeight:400,
                                  color:'#6C757D'
                                }}
                              />

                              <span
                                onClick={toggleCategoryDropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {categoriesOpen ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {categoriesOpen && (
                              <div
                                className="dropdown-menu show mt-1"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {filteredCategories.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {filteredCategories.map((item) => {
                                  const isSelected = tempCategories.includes(
                                    item.name
                                  );

                                  return (
                                    <div
                                      key={item.id}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() => {
                                        toggleCategories(item.name);
                                        setCategorySearch("");
                                      }}
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529'
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          width: "100%",
                                        }}
                                      >
                                        {/* Left text */}
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "4px",
                                          }}
                                        >
                                          {/* Parent category */}
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: 400,
                                              fontFamily: "Montserrat",
                                              color: "#212529",
                                            }}
                                          >
                                            {item.name}
                                          </span>

                                          {/* Parent Parent >> Parent */}
                                          {item.parent_name && item.name && (
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                fontFamily: "Montserrat",
                                                color: "#6C757D",
                                              }}
                                            >
                                              {item.parent_name} { item.parent_parent_name && (" >> " + item.parent_parent_name)}
                                            </span>
                                          )}
                                        </div>

                                        {/* Selected check */}
                                        {isSelected && (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                          >
                                            <path
                                              d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                              stroke="#6C757D"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* -------- Type -------- */}
                          {/* Type */}
                          <div
                            ref={typeRef}
                            className="position-relative"
                            style={{ padding: "5px 20px 0 20px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                              }}
                            >
                              Type
                            </label>

                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setTypesOpen(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {tempTypes.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleTypes(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {tempTypes.length === 0 && (
                                <span
                                  style={{
                                    color:'#6C757D',
                                    fontSize: "14px",
                                    fontFamily: "Montserrat",
                                    userSelect: "none",
                                  }}
                                >
                                  Select...
                                </span>
                              )}

                              <span
                                onClick={toggleTypeDropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {typesOpen ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {typesOpen && (
                              <div
                                className="dropdown-menu show mt-1"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {filteredTypes.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {filteredTypes.map((item) => {
                                  const isSelected = tempTypes.includes(item);
                                  return (
                                    <div
                                      key={item}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() => toggleTypes(item)}
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529',
                                        fontSize:14
                                      }}
                                    >
                                      <span>{item}</span>
                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ================= FOOTER (FIXED BOTTOM) ================= */}
                        <div
                          style={{
                            padding: "16px",
                            background: "#FFFFFF",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {/* Clear */}
                          <button
                            onClick={handleClearFilters}
                            style={{
                              background: "none",
                              border: "none",
                              fontFamily: "Montserrat",
                              fontSize: 12,
                              fontWeight: 600,
                              color: "#000",
                              cursor: "pointer",
                            }}
                          >
                            Clear
                          </button>

                          {/* Right buttons */}
                          <div style={{ display: "flex", gap: 8 }}>
                            <button
                              onClick={handleCloseFilterPopup}
                              style={{
                                height: 34,
                                minWidth: 100,
                                borderRadius: 8,
                                border: "1px solid #212529",
                                background: "#FFFFFF",
                                fontFamily: "Montserrat",
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              Cancel
                            </button>

                            <button
                              onClick={handleApplyFilters}
                              style={{
                                height: 34,
                                minWidth: 100,
                                borderRadius: 8,
                                border: "none",
                                background: "#212529",
                                color: "#FFFFFF",
                                fontFamily: "Montserrat",
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {successMessage && (
                    <AlertNotification
                      type="success"
                      recordName="Stock"
                      action={
                        successMessage.includes("Archived")
                          ? "archive"
                          : successMessage.includes("Discarded")
                            ? "discard"
                            : successMessage.includes("Activated")
                              ? "activate"
                              : successMessage.includes("Deactivated")
                                ? "deactivate"
                                : "create"
                      }
                      onClose={() => setSuccessMessage("")}
                    />
                  )}
                  {/* Table */}
                  <div className="table-wrapper" style={{ border: "none" }}>
                    <div className={activeTab === "stock-list" ? "stock-wrapper" : "archived-wrapper"}>
                      <DynamicTable
                        columns={columns}
                        data={pageData.filter((row) => !row.is_archived)}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSort={handleSort}
                        onRowClick={onRowClick}
                        onActionClick={(id) => toggleDropdown(id)}
                        noImage={noImage}
                        selectedIds={selectedIds}
                        dropdownOpenId={dropdownOpenId}
                        suppressHighlight={suppressHighlight}
                        buttonRefs={buttonRefs}
                        rowKey="id"
                        searchTerm={searchTerm}
                        selectedStatuses={selectedStatuses}
                        selectedParentBrands={""}
                        emptyImage={emptyImage}
                        emptyTitle={emptyTitle}
                        emptyMessage={emptyMessage}
                        showActions={true}
                      />
                    </div>

                    {/* Per‐row dropdown menu */}
                    {dropdownOpenId !== null && (
                      <div
                        ref={dropdownRef}
                        className="backdrop-cls"
                        style={{
                          position: "absolute",
                          top: dropdownPosition.top,
                          left: dropdownPosition.left,
                          background: "white",
                          boxShadow: "0px 1px 4px 0px #0000001A",
                          zIndex: 1000,
                          minWidth: 152,
                          borderRadius: 8,
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="btn-align-forall">
                          <div className="common-for-all">
                            <button
                              onClick={() => {
                                const row = pageData.find(
                                  (d) => d.id === dropdownOpenId
                                );
                                onRowClick(row);
                                setDropdownOpenId(null);
                              }}
                            >
                              View Stock Details
                            </button>
                          </div>

                          <div className="common-for-all">
                            <button
                              onClick={() => {
                                setSaveModalOpen(true);
                                setDropdownOpenId(null);

                                history.push(
                                  `/inventory/stock/${activeRow.id}/stockInstance`,
                                  {
                                    stock: activeRow,
                                    activeTab,
                                    page: currentPage,
                                    tab: "",
                                    reopenDrawer: false,
                                    stockId: activeRow.id,
                                  }
                                );
                              }}
                            >
                              View All StockInstances
                            </button>
                          </div>

                          {activeRow && (
                            <div className="common-for-all">
                              {activeRow.status == "Active" ? (
                                <button
                                  onClick={() => {
                                    setSelectedStockId(activeRow.id);
                                    setDeactivateModalOpen(true);
                                    setDropdownOpenId(null);
                                    setActionFromDrawer(false);
                                  }}
                                >
                                  Deactivate
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    setSelectedStockId(activeRow.id);
                                    handleDeactivateStock(activeRow.id);
                                    setDropdownOpenId(null);
                                    setActionFromDrawer(false);
                                  }}
                                >
                                  Activate
                                </button>
                              )}
                            </div>
                          )}

                          <div className="common-for-all">
                            <button
                              onClick={() => {
                                setSelectedArchiveStockId(activeRow.id);
                                setArchivedModalOpen(true);
                                setToolbarDropdownOpen(false);
                                setActionFromDrawer(false);
                              }}
                              className="deactivate-cls"
                            >
                              Archive
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Pagination */}

                  <div className="pagination">
                    <div className="pagination-info">
                      {`${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(
                        currentPage * PAGE_SIZE,
                        filtered.length
                      )} of ${filtered.length}`}
                    </div>

                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                  </div>
                  {saveModalOpen && (
                    <>
                      <div className="drawer-overlay" />
                      <div
                        className="entity-drawer modal-popup-cls"
                        ref={saveRef}
                        style={{
                          maxWidth: 650,
                          margin: "0 auto",
                          background: "white",
                          borderRadius: 12,
                          zIndex: 1050,
                          padding: 24,
                          position: "fixed",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          height: "auto",
                          right: "auto",
                          overflow: "inherit",
                        }}
                      >
                        <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                          <button
                            className="close-btn"
                            onClick={() => setSaveModalOpen(false)}
                          >
                            <X size={20} />
                          </button>
                        </div>
                        <h3
                          style={{
                            textAlign: "left",
                            color: "#212529",
                            fontSize: "20px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            fontFamily: "Montserrat",
                            marginBottom: "5px",
                          }}
                        >
                          New feature in Progress
                        </h3>
                        <p
                          style={{
                            marginBottom: "0",
                            textAlign: "left",
                            color: "#6C757D",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontFamily: "Montserrat",
                          }}
                        >
                          Work in Progress
                        </p>
                        <div
                          className="drawer-footer"
                          style={{ paddingTop: "10px" }}
                        >
                          <button
                            className="btn-save"
                            onClick={handleSaveConfirm}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="drawer-container" ref={drawerContainerRef}>
              {/* Single‐row Drawer (unchanged) */}
              {drawerOpen &&
                selectedRow &&
                (() => {
                  const pendingCount =
                    selectedRow.pending?.reduce(
                      (sum, item) => sum + item.count,
                      0
                    ) || 0;
                  const total =
                    Number(selectedRow.available || 0) + pendingCount;
                  return (
                    <>
                      <div className="drawer-overlay main-drawer-overlay" />
                      <div className="entity-drawer" ref={drawerRef}>
                        <div
                          className="drawer-header"
                          style={{ backgroundColor: "#F8F9FA" }}
                        >
                          <h3>Stock Info</h3>
                          <button
                            className="close-btn"
                            onClick={() => {
                              setDrawerOpen(false);
                              setSelectedIds((ids) =>
                                ids.filter((id) => id !== selectedRow?.id)
                              );
                              setSelectedRow(null);
                            }}
                          >
                            <X size={24} />
                          </button>
                        </div>
                        {/* info drawer */}
                        <div
                          className="main-drawer-inner"
                          style={{ marginTop: "50px" }}
                        >
                          <div className="drawer-title d-flex align-items-center justify-content-between">
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "8px" }}
                            >
                              <img
                                src={selectedRow.avatar}
                                alt="avatar"
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 6,
                                  objectFit: "cover",
                                  flexShrink: 0,
                                }}
                              />

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {/* Title */}
                                <span
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "#212529",
                                    lineHeight: "18px",
                                  }}
                                >
                                  {selectedRow?.name}
                                </span>

                                {/* Subtitle */}
                                <span
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "#6C757D",
                                    lineHeight: "16px",
                                  }}
                                >
                                  {selectedRow?.variant}
                                </span>
                              </div>
                            </div>
                            <div className="entities-tab flex-row align-items-center gap-3">
                              <div className="toolbar">
                                <div
                                  className="toolbar-right"
                                  style={{ position: "relative" }}
                                  ref={toolbarRef}
                                >
                                  <button
                                    className="drawer-dots"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleToolbarDropdown();
                                    }}
                                  >
                                    <MoreHorizontal size={18} />
                                  </button>

                                  {toolbarDropdownOpen && (
                                    <div
                                      className="backdrop-cls"
                                      style={{
                                        position: "absolute",
                                        top: 40,
                                        right: 0,
                                        background: "white",
                                        boxShadow: "0px 1px 4px 0px #0000001A",
                                        zIndex: 1000,
                                        minWidth: 200,
                                        borderRadius: 8,
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <div className="btn-align-forall">
                                        <div className="common-for-all">
                                          <button
                                            onClick={() => {
                                              setInstancesDrawerOpen(true);
                                              setDrawerOpen(false);
                                              history.push(
                                                `/inventory/stock/${selectedRow.id}/stockInstance`,
                                                {
                                                  stock: selectedRow,
                                                  activeTab,
                                                  page: currentPage,
                                                  tab: drawerTab,
                                                  reopenDrawer: true,
                                                  stockId: selectedRow.id,
                                                }
                                              );
                                            }}
                                          >
                                            View All StockInstances
                                          </button>
                                        </div>
                                        {selectedRow && (
                                          <div className="common-for-all">
                                            {selectedRow.status === "Active" ? (
                                              <button
                                                onClick={() => {
                                                  // Deactivate → open confirmation modal
                                                  setSelectedStockId(
                                                    selectedRow.id
                                                  );
                                                  setDeactivateModalOpen(true);
                                                  setToolbarDropdownOpen(false);
                                                  setActionFromDrawer(true);
                                                }}
                                              >
                                                Deactivate
                                              </button>
                                            ) : (
                                              <button
                                                onClick={() => {
                                                  // Activate → direct API call
                                                  handleDeactivateStock(
                                                    selectedRow.id
                                                  );
                                                  setToolbarDropdownOpen(false);
                                                  setActionFromDrawer(true);
                                                }}
                                              >
                                                Activate
                                              </button>
                                            )}
                                          </div>
                                        )}

                                        <div className="common-for-all">
                                          <button
                                            className="deactivate-cls"
                                            onClick={() => {
                                              setActionFromDrawer(true);
                                              setSelectedArchiveStockId(
                                                selectedRow.id
                                              );
                                              setArchivedModalOpen(true);
                                              setToolbarDropdownOpen(false);
                                            }}
                                          >
                                            Archive
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="drawer-tabs">
                            <button
                              className={
                                drawerTab === "entity-info" ? "active" : ""
                              }
                              onClick={() => setDrawerTab("entity-info")}
                            >
                              General
                            </button>
                            <button
                              className={
                                drawerTab === "additional-info" ? "active" : ""
                              }
                              onClick={() => setDrawerTab("additional-info")}
                            >
                              Additional
                            </button>
                          </div>

                          <div className="drawer-content">
                            {drawerTab === "entity-info" && (
                              <div className="tab-panel entity-info-panel">
                                {/*Stock Summary Cards*/}
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    marginTop: "16px",
                                  }}
                                >
                                  {/* ================= LEFT CARD ================= */}
                                  <div
                                    style={{
                                      flex: 1,
                                      border: "1px solid #E9ECEF",
                                      borderRadius: "8px",
                                      padding: "12px",
                                      background: "#fff",
                                      boxShadow: "1px 1px 4px #818181ff",
                                      display: "flex",
                                      flexDirection: "column", // ✅ important
                                    }}
                                  >
                                    {/* Title */}
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#212529",
                                        fontFamily: "Montserrat",
                                      }}
                                    >
                                      In Stock & Sellable
                                    </div>

                                    {/* List pushed to bottom */}
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: "12px",
                                        fontFamily: "Montserrat",
                                        marginTop: "auto", // ✅ pushes list to bottom
                                        paddingTop: "8px",
                                      }}
                                    >
                                      {(
                                        selectedRow?.inStock_Sellable || []
                                      ).map((item, index) => (
                                        <div
                                          key={index}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          {/* Dot */}
                                          <span
                                            style={{
                                              width: 6,
                                              height: 6,
                                              borderRadius: "50%",
                                              backgroundColor: item.color,
                                              marginRight: 8,
                                              display: "inline-block",
                                              flexShrink: 0,
                                            }}
                                          />

                                          {/* Label */}
                                          <span
                                            style={{
                                              color: "#6C757D",
                                              fontFamily: "Montserrat",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {item.type}
                                          </span>

                                          {/* Count */}
                                          <span
                                            style={{
                                              marginLeft: "auto",
                                              fontWeight: 600,
                                              color: "#212529",
                                              fontFamily: "Montserrat",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {item.count}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  </div>

                                  {/* ================= RIGHT CARD ================= */}
                                  <div
                                    style={{
                                      flex: 1,
                                      border: "1px solid #E9ECEF",
                                      borderRadius: "8px",
                                      padding: "12px",
                                      background: "#fff",
                                      boxShadow: "1px 1px 4px #818181ff",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        marginBottom: "8px",
                                        fontFamily: "Montserrat",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#212529",
                                          fontSize: "14px",
                                        }}
                                      >
                                        Pending
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: "12px",
                                        fontFamily: "Montserrat",
                                      }}
                                    >
                                      {(selectedRow?.pending || []).map(
                                        (p, i) => (
                                          <div
                                            key={i}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <span
                                              style={{
                                                color: p.color,
                                                fontSize: "14px",
                                                marginRight: 6,
                                              }}
                                            >
                                              ●
                                            </span>

                                            <span style={{ color: "#6C757D" }}>
                                              {p.type}
                                            </span>

                                            <span
                                              style={{
                                                marginLeft: "auto",
                                                fontWeight: 600,
                                                color: "#212529",
                                              }}
                                            >
                                              {p.count}
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* Basic Info in info drawer */}
                                {/* Title */}
                                <div
                                  style={{
                                    marginTop: "20px",
                                    border: "1px solid #E9ECEF",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    background: "#fff",
                                  }}
                                >
                                  {/* Header */}
                                  <div
                                    style={{
                                      backgroundColor: "#F8F9FA",
                                      padding: "15px 20px",
                                      fontSize: 14,
                                      fontWeight: 600,
                                      color: "#212529",
                                    }}
                                  >
                                    Basic Info
                                  </div>

                                  {/* Body */}
                                  <div
                                    style={{
                                      padding: "16px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        columnGap: 24,
                                        rowGap: 10,
                                        fontSize: 12,
                                        color: "#212529",
                                      }}
                                    >
                                      {/* SPU & SKU */}
                                      <div
                                        style={{
                                          fontWeight: 700,
                                          gridColumn: "1 / -1",
                                        }}
                                      >
                                        SPU & SKU
                                      </div>
                                      <br></br>
                                      <div
                                        style={{
                                          marginTop: '-30px',
                                          gridColumn: "1 / -1", // FULL ROW
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 6,
                                          minWidth: 0,
                                          overflow: "hidden",
                                        }}
                                      >
                                        {/* Avatar */}
                                        <img
                                          src={selectedRow.avatar}
                                          alt=""
                                          style={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 4,
                                            flexShrink: 0,
                                          }}
                                        />

                                        {/* Text */}
                                        <span
                                          style={{
                                            color: "#0D6EFD",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            minWidth: 0,
                                            fontSize: 12
                                            // flex: 1, // allows shrinking
                                          }}
                                          title={`${selectedRow.name} ${selectedRow.variant}`}
                                          onClick={(e) => {
                                            setSelectedRow(selectedRow); // pass full row
                                            setSkuDrawerOpen(true);
                                          }}
                                        >
                                          {selectedRow.name}{" "}
                                          {selectedRow.variant}
                                        </span>

                                        {/* External link icon */}
                                        <SquareArrowOutUpRight
                                          size={14}
                                          strokeWidth={2}
                                          style={{
                                            color: "#0D6EFD",
                                            cursor: "pointer",
                                            flexShrink: 0,
                                          }}
                                          onClick={(e) => {
                                            setSelectedRow(selectedRow); // pass full row
                                            setSkuDrawerOpen(true);
                                          }}
                                        />
                                      </div>

                                      {/* Condition L1 */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Condition L1
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.condition}
                                        </span>
                                      </div>

                                      {/* Condition L2 */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Condition L2
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.grading}
                                        </span>
                                      </div>

                                      {/* Status */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Status
                                        </div>
                                        <span
                                          style={{
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                            backgroundColor:
                                              selectedRow.status === "Active"
                                                ? "#D1FADF"
                                                : "#FEE4E2",
                                            color:
                                              selectedRow.status === "Active"
                                                ? "#027A48"
                                                : "#B42318",
                                          }}
                                        >
                                          {selectedRow.status}
                                        </span>
                                      </div>

                                      {/* Brand */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Brand
                                        </div>
                                        <div>{selectedRow.brand}</div>
                                      </div>

                                      {/* Category */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Category
                                        </div>
                                        <div>{selectedRow.category}</div>
                                      </div>
                                      <div></div>
                                      {/* Type */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Type
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.type}
                                        </span>
                                      </div>

                                      {/* ID */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          ID
                                        </div>
                                        <div>{selectedRow.id}</div>
                                      </div>

                                      {/* Open ID */}
                                      <div style={{ gridColumn: "1 / -1" }}>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Open ID
                                        </div>

                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {/* Open ID text */}
                                          <span
                                            style={{
                                              color: "#0D6EFD",
                                              cursor: "pointer",
                                              textDecoration: "underline",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              maxWidth: 420, // keeps single line
                                              flexShrink: 1,
                                              fontWeight:500,
                                              fontSize:12
                                            }}
                                            title={selectedRow.openId || "—"}
                                            onClick={() => {
                                              // navigator.clipboard.writeText(selectedRow.openId);
                                              navigator.clipboard.writeText(
                                                selectedRow.openId || "—"
                                              );
                                              setCopied(true);
                                              setTimeout(
                                                () => setCopied(false),
                                                1500
                                              );
                                            }}
                                          >
                                            {/* {selectedRow.openId} */}
                                            {selectedRow.openId || "—"}
                                          </span>

                                          {/* Copy icon + tooltip anchor */}
                                          <span
                                            style={{
                                              position: "relative", // ✅ anchor for tooltip
                                              display: "inline-flex",
                                              alignItems: "center",
                                              flexShrink: 0,
                                            }}
                                            onClick={() => {
                                              // navigator.clipboard.writeText(selectedRow.openId);
                                              navigator.clipboard.writeText(
                                                selectedRow.openId || "—"
                                              );
                                              setCopied(true);
                                              setTimeout(
                                                () => setCopied(false),
                                                1500
                                              );
                                            }}
                                          >
                                            <Copy
                                              size={14}
                                              style={{
                                                color: "#0D6EFD",
                                                cursor: "pointer",
                                              }}
                                            />

                                            {/* ✅ Tooltip (NOT clipped now) */}
                                            {copied && (
                                              <span
                                                style={{
                                                  fontSize: 12,
                                                  color: "#0D6EFD",
                                                  fontWeight: 500,
                                                  marginLeft: 4,
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Copied!
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      </div>

                                      {/* Created By */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Created By
                                        </div>
                                        <div>
                                          {selectedRow.createdBy || "NA"}
                                        </div>
                                      </div>

                                      {/* Created Time */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Created Time
                                        </div>
                                        <div>{selectedRow.createdAt}</div>
                                      </div>

                                      {/* Last Modified By */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Last Modified By
                                        </div>
                                        <div>
                                          <div>
                                            {selectedRow.modifiedBy || "NA"}
                                          </div>
                                        </div>
                                      </div>

                                      {/* Last Modified Time */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Last Modified Time
                                        </div>
                                        <div>
                                          {selectedRow.lastModifiedTime}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {drawerTab === "stock-instances" && (
                              <div className="tab-panel stock-instances-panel">
                                <div
                                  className="entities-tab"
                                  style={{ padding: 0, paddingTop: "20px" }}
                                >
                                  <div className="toolbar">
                                    <div className="toolbar-left">
                                      <div className="search-box">
                                        <Search size={20} />
                                        <input
                                          type="text"
                                          placeholder="Search…"
                                          value={imeiSearchInput}
                                          onChange={(e) => {
                                            setImeiSearchInput(e.target.value);
                                            setPageInView(1); // reset pagination if needed
                                          }}
                                        />
                                      </div>
                                      <button
                                        className="icon-btn"
                                        onClick={() => {
                                          setTempSelectedStock(selectedStock);
                                          setStockfilterDrawerOpen(true);
                                        }}
                                      >
                                        <Funnel size={18} /> Filter
                                        {selectedStock.length > 0 && (
                                          <span
                                            style={{
                                              background: "#212529",
                                              color: "#fff",
                                              borderRadius: "50%",
                                              fontSize: "12px",
                                              width: 20,
                                              height: 20,
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              marginLeft: 6,
                                            }}
                                          >
                                            {selectedStock.length}
                                          </span>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                  <div className="row gy-3 gy-md-0">
                                    <div className="col-md-4 d-flex">
                                      <div
                                        style={{
                                          border: "1px solid #DEE2E6",
                                          borderRadius: 8,
                                          padding: 10,
                                          textAlign: "right",
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          Reserved
                                        </p>
                                        <h6
                                          style={{
                                            fontSize: 28,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                            marginBottom: 0,
                                            marginTop: "auto",
                                          }}
                                        >
                                          {imeiStats.reserved}
                                        </h6>
                                      </div>
                                    </div>
                                    <div className="col-md-4 d-flex">
                                      <div
                                        style={{
                                          border: "1px solid #DEE2E6",
                                          borderRadius: 8,
                                          padding: 10,
                                          textAlign: "right",
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          Available
                                        </p>
                                        <h6
                                          style={{
                                            fontSize: 28,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                            marginBottom: 0,
                                            marginTop: "auto",
                                          }}
                                        >
                                          {imeiStats.available}
                                        </h6>
                                      </div>
                                    </div>
                                    <div className="col-md-4 d-flex">
                                      <div
                                        style={{
                                          border: "1px solid #DEE2E6",
                                          borderRadius: 8,
                                          padding: 10,
                                          textAlign: "right",
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          Pending
                                        </p>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          {Object.entries(
                                            imeiStats.pendingTotals
                                          ).map(([type, data]) => (
                                            <div
                                              key={type}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: 11,
                                              }}
                                            >
                                              <span
                                                style={{
                                                  color: data.color,
                                                  fontSize: 14,
                                                  marginRight: 6,
                                                }}
                                              >
                                                ●
                                              </span>
                                              <span
                                                style={{
                                                  color: "#6C757D",
                                                  marginRight: 8,
                                                }}
                                              >
                                                {type}
                                              </span>
                                              <span
                                                style={{
                                                  marginLeft: "auto",
                                                  color: "#212529",
                                                }}
                                              >
                                                {data.count}
                                              </span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="table-wrapper">
                                    <table
                                      className="entities-table"
                                      ref={tableRef}
                                      style={{ minWidth: "unset" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th>
                                            <span>
                                              IMEI/Barcode{" "}
                                              <ChevronsUpDown size={10} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Branch{" "}
                                              <ChevronsUpDown size={10} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Reserved{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Available{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Pending{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th
                                            className="sticky-action-col"
                                            style={{ textAlign: "center" }}
                                          >
                                            Action
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {visibleImeiRows.map((item, idx) => (
                                          <tr
                                            key={idx}
                                            className={
                                              idx % 2 === 1 ? "striped" : ""
                                            }
                                          >
                                            <td className="py-3">
                                              <a
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="d-flex align-items-center gap-1 me-3"
                                                style={{
                                                  color: "#2C7BE5",
                                                  textDecoration: "underline",
                                                  fontWeight: "600",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.imei}
                                                <SquareArrowOutUpRight
                                                  size={14}
                                                  strokeWidth={3}
                                                />
                                              </a>
                                            </td>
                                            <td className="py-3">
                                              {item.location}
                                            </td>
                                            <td>{item.reserved}</td>
                                            <td>{item.available}</td>
                                            <td>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  gap: 4,
                                                }}
                                              >
                                                {item.pending.map((p, i) => (
                                                  <div
                                                    key={i}
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      fontSize: 11,
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: p.color,
                                                        fontSize: 14,
                                                        marginRight: 6,
                                                      }}
                                                    >
                                                      ●
                                                    </span>
                                                    <span
                                                      style={{
                                                        color: "#6C757D",
                                                        marginRight: 8,
                                                      }}
                                                    >
                                                      {p.type}
                                                    </span>
                                                    <span
                                                      style={{
                                                        marginLeft: "auto",
                                                        marginRight: "8px",
                                                      }}
                                                    >
                                                      {p.count}
                                                    </span>
                                                  </div>
                                                ))}
                                              </div>
                                            </td>

                                            <td
                                              className="sticky-action-col"
                                              style={{
                                                textAlign: "center",
                                                position: "relative",
                                              }}
                                            >
                                              <button
                                                className="icon-btn"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setImeiDropdownOpenId(
                                                    (prevId) =>
                                                      prevId === item.id
                                                        ? null
                                                        : item.id
                                                  );
                                                }}
                                              >
                                                <MoreHorizontal size={20} />
                                              </button>

                                              {imeiDropdownOpenId ===
                                                item.id && (
                                                  <div
                                                    className="backdrop-cls"
                                                    style={{
                                                      position: "absolute",
                                                      top: "40px",
                                                      right: "0",
                                                      background: "white",
                                                      boxShadow:
                                                        "0px 1px 4px 0px #0000001A",
                                                      zIndex: 1000,
                                                      minWidth: 152,
                                                      borderRadius: 8,
                                                    }}
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                  >
                                                    <div className="btn-align-forall">
                                                      <div className="common-for-all">
                                                        <button className="deactivate-cls">
                                                          Stock Out
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                            </td>
                                          </tr>
                                        ))}
                                        {visibleImeiRows.length === 0 && (
                                          <tr>
                                            <td
                                              colSpan="5"
                                              className="py-3 text-center"
                                            >
                                              No results
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )}
                            {drawerTab === "configuration" && (
                              <div style={{ paddingTop: 10 }}>
                                {/* ===== BASIC INFO CARD ===== */}
                                <div
                                  style={{
                                    border: "1px solid #E9ECEF",
                                    borderRadius: 12,
                                    background: "#fff",
                                    marginBottom: 16,
                                    overflow: "hidden",
                                  }}
                                >
                                  {/* Header */}
                                  <div
                                    style={{
                                      background: "#F8F9FA",
                                      padding: "15px 20px",
                                      fontSize: 13,
                                      fontWeight: 600,
                                    }}
                                  >
                                    Basic Info
                                  </div>

                                  {/* Body */}
                                  <div style={{ padding: 16 }}>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        columnGap: 24,
                                        rowGap: 16,
                                        fontSize: 12,
                                      }}
                                    >
                                      {/* Spec Name */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Spec Name
                                        </div>
                                        <div>{selectedRow.name}</div>
                                      </div>

                                      {/* SKU Code */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          SKU Code
                                        </div>
                                        <div>{selectedRow.sku_code}</div>
                                      </div>

                                      {/* Enable */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Enable
                                        </div>
                                        <span
                                          style={{
                                            background: "#D1FADF",
                                            color: "#027A48",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          YES
                                        </span>
                                      </div>

                                      {/* Color */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Color
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.variant?.split(",")[0] ||
                                            "—"}
                                        </span>
                                      </div>

                                      {/* RAM */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          RAM
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          8G
                                        </span>
                                      </div>

                                      {/* Storage */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Storage
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.variant
                                            ?.split(",")[1]
                                            ?.trim() || "—"}
                                        </span>
                                      </div>

                                      {/* Open ID (FULL WIDTH) */}
                                      <div style={{ gridColumn: "1 / -1" }}>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Open ID
                                        </div>

                                        <div
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            position: "relative",
                                            maxWidth: "100%",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: "#2C7BE5",
                                              cursor: "pointer",
                                              textDecoration: "underline",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              maxWidth: 420, // ✅ keeps single line
                                              flexShrink: 1,
                                            }}
                                            title={selectedRow.openId || "—"}
                                            onClick={() =>
                                              // navigator.clipboard.writeText(selectedRow.openId)
                                              navigator.clipboard.writeText(
                                                selectedRow.openId || "—"
                                              )
                                            }
                                          >
                                            {/* {selectedRow.openId} */}
                                            {selectedRow.openId || "—"}
                                          </span>

                                          {/* Copy icon + tooltip anchor */}
                                          <span
                                            style={{
                                              position: "relative", // ✅ anchor for tooltip
                                              display: "inline-flex",
                                              alignItems: "center",
                                              flexShrink: 0,
                                            }}
                                            onClick={() => {
                                              // navigator.clipboard.writeText(selectedRow.openId);
                                              navigator.clipboard.writeText(
                                                selectedRow.openId || "—"
                                              );
                                              setCopied(true);
                                              setTimeout(
                                                () => setCopied(false),
                                                1200
                                              );
                                            }}
                                          >
                                            <Copy
                                              size={14}
                                              style={{
                                                color: "#2C7BE5",
                                                cursor: "pointer",
                                              }}
                                            />

                                            {copied && (
                                              <span
                                                style={{
                                                  position: "absolute",
                                                  top: "-26px",
                                                  left: "50%",
                                                  transform: "translateX(-50%)",
                                                  background: "#212529",
                                                  color: "#fff",
                                                  fontSize: 10,
                                                  padding: "4px 8px",
                                                  borderRadius: 6,
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Copied
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* ===== BUSINESS INFO CARD ===== */}
                                <div
                                  style={{
                                    border: "1px solid #E9ECEF",
                                    borderRadius: 12,
                                    background: "#fff",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      background: "#F8F9FA",
                                      padding: "10px 16px",
                                      fontSize: 13,
                                      fontWeight: 600,
                                    }}
                                  >
                                    Business Info
                                  </div>

                                  <div style={{ padding: 16 }}>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        columnGap: 24,
                                        rowGap: 16,
                                        fontSize: 12,
                                      }}
                                    >
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          GTIN
                                        </div>
                                        <div>8887654109728</div>
                                      </div>

                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          MSRP
                                        </div>
                                        <div>SGD 1,038.00</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {drawerTab === "additional-info" && (
                              <div style={{ paddingTop: 10 }}>
                                {/* ===== BASIC INFO CARD ===== */}
                                <div
                                  style={{
                                    border: "1px solid #E9ECEF",
                                    borderRadius: 12,
                                    background: "#fff",
                                    marginBottom: 16,
                                    overflow: "hidden",
                                  }}
                                >
                                  {/* Header */}
                                  <div
                                    style={{
                                      background: "#F8F9FA",
                                      padding: "10px 16px",
                                      fontSize: 13,
                                      fontWeight: 600,
                                    }}
                                  >
                                    Notes
                                  </div>

                                  {/* Body */}
                                  <div style={{ padding: 16 }}>
                                    <div
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      {/* Spec Name */}
                                      <div>
                                        <div>
                                          {selectedRow.sku_notes
                                            ? selectedRow.sku_notes
                                            : "NA"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}

              {skuDrawerOpen && (
                <SkuInfoDrawer
                  setDrawerOpen={setDrawerOpen}
                  selectedRow={selectedRow}
                  setSelectedRow={setSelectedRow}
                  setSkuDrawerOpen={setSkuDrawerOpen}
                />
              )}

              {stockfilterDrawerOpen &&
                (() => {
                  return (
                    <>
                      <div
                        className="drawer-overlay filter-drawer-overlay"
                        onMouseDown={(e) => {
                          // stop event from reaching document click handlers (so main drawer doesn't close)
                          e.stopPropagation();
                          closeAllDropdowns();
                          setStockfilterDrawerOpen(false); // clicking overlay closes only the filter drawer
                        }}
                      />

                      <div className="filter-drawer" ref={filterDrawerRef}>
                        <div className="drawer-header">
                          <div className="d-flex align-items-center gap-1">
                            <h3>Filter</h3>
                          </div>

                          <button
                            className="close-btn"
                            onClick={() => {
                              closeAllDropdowns();
                              setStockfilterDrawerOpen(false); // just close the filter drawer, leave main drawer as-is
                            }}
                          >
                            <X size={24} />
                          </button>
                        </div>
                        <div className="main-company-body-inner d-flex flex-column h-100">
                          <div className="main-drawer-inner">
                            {/* ─── ROW 1: Branch ─────────────────────────────────────── */}
                            <div className="row gappingcls-added">
                              <div className="col-12">
                                <div
                                  className="info-inner"
                                  ref={stockRef}
                                  style={{ position: "relative" }}
                                >
                                  <label className="form-label d-flex align-items-center gap-2">
                                    Branch
                                  </label>

                                  {/* CLOSED VIEW: tags + arrow */}
                                  <div
                                    className="select-box form-control common-input-all"
                                    onClick={toggleStock}
                                    style={{
                                      padding: "0.5rem",
                                      minHeight: "40px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {tempSelectedStock.length > 0 ? (
                                      tempSelectedStock.map((d) => (
                                        <span
                                          key={d.value}
                                          className="tag"
                                          style={{
                                            backgroundColor: "#FFEB00",
                                            color: "#212529",
                                            borderRadius: "16px",
                                            padding: "4px 8px",
                                            margin: "2px",
                                            display: "flex",
                                            alignItems: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          {d.label}
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setTempSelectedStock((prev) =>
                                                prev.filter(
                                                  (item) =>
                                                    item.value !== d.value
                                                )
                                              );
                                            }}
                                            style={{
                                              background: "none",
                                              border: "none",
                                              marginLeft: "20px",
                                              cursor: "pointer",
                                              fontSize: "16px",
                                              padding: "0",
                                              lineHeight: "14px",
                                            }}
                                          >
                                            <X size={14} strokeWidth={3} />
                                          </button>
                                        </span>
                                      ))
                                    ) : (
                                      <span
                                        style={{
                                          color: "#999",
                                          fontSize: "0.9rem",
                                        }}
                                      >
                                        Select Branch
                                      </span>
                                    )}

                                    {/* Selected count */}
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginLeft: "auto",
                                        gap: "0.25rem",
                                        fontSize: "0.8rem",
                                        color: "#666",
                                      }}
                                    >
                                      <ChevronDown
                                        size={16}
                                        style={{
                                          transform: isStockOpen
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                          transition: "transform 0.2s",
                                          userSelect: "none",
                                        }}
                                      />
                                    </span>
                                  </div>

                                  {/* DROPDOWN PANEL (visible when isStockOpen) */}
                                  {isStockOpen && (
                                    <div
                                      className="options-container"
                                      style={{
                                        border: "1px solid #6c757d",
                                        borderRadius: "8px",
                                        marginTop: "4px",
                                        maxHeight: "270px",
                                        overflowY: "auto",
                                        background: "#fff",
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        zIndex: 1000,
                                        width: "100%",
                                        boxshadow: "0px 1px 4px 0px #0000001A",
                                      }}
                                      onWheel={(e) => e.preventDefault()}
                                    >
                                      {/* Archived Search input with icon */}
                                      <div
                                        style={{
                                          padding: "0.5rem",
                                          position: "relative",
                                        }}
                                      >
                                        <Search
                                          size={18}
                                          style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "18px",
                                            transform: "translateY(-50%)",
                                            color: "#6C757D",
                                            pointerEvents: "none",
                                          }}
                                        />
                                        <input
                                          type="text"
                                          className="search-input select-box form-control common-input-all"
                                          placeholder="Search..."
                                          value={stockSearch}
                                          onChange={(e) =>
                                            setStockSearch(e.target.value)
                                          }
                                          style={{
                                            width: "100%",
                                            padding:
                                              "0.5rem 0.5rem 0.5rem 2rem",
                                            fontSize: "0.9rem",
                                            outline: "none",
                                          }}
                                        />
                                      </div>

                                      {/* Options list */}
                                      <ul
                                        className="options-list custom-check"
                                        style={{
                                          listStyle: "none",
                                          margin: 0,
                                          padding: "1.25rem",
                                          maxHeight: "420px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {[
                                          ...new Set([
                                            ...allStock.filter((d) =>
                                              d.label
                                                .toLowerCase()
                                                .includes(
                                                  stockSearch
                                                    .trim()
                                                    .toLowerCase()
                                                )
                                            ),
                                            ...tempSelectedStock.filter(
                                              (s) =>
                                                !allStock.some(
                                                  (d) => d.value === s.value
                                                )
                                            ),
                                          ]),
                                        ].map((d) => (
                                          <li
                                            key={d.value}
                                            style={{ marginBottom: "0.5rem" }}
                                          >
                                            <label
                                              className="option-item"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer",
                                                fontSize: "0.9rem",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={tempSelectedStock.some(
                                                  (item) =>
                                                    item.value === d.value
                                                )}
                                                onChange={() =>
                                                  handleTempStockCheckbox(d)
                                                }
                                                style={{ marginRight: "8px" }}
                                              />
                                              {d.label}
                                            </label>
                                          </li>
                                        ))}

                                        {allStock.filter((d) =>
                                          d.label
                                            .toLowerCase()
                                            .includes(
                                              stockSearch.trim().toLowerCase()
                                            )
                                        ).length === 0 &&
                                          tempSelectedStock.length === 0 && (
                                            <li
                                              style={{
                                                color: "#999",
                                                textAlign: "center",
                                                fontSize: "0.9rem",
                                              }}
                                            >
                                              No branch found
                                            </li>
                                          )}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-auto main-drawer-inner">
                            <div className="edit-organisation-info d-flex justify-content-end align-items-center gap-2 mt-auto">
                              <button
                                className="dark-button"
                                type="button"
                                onClick={() => {
                                  closeAllDropdowns();
                                  setStockfilterDrawerOpen(false);
                                  setTempSelectedStock(selectedStock); // discard any changes, keep main drawer visible
                                }}
                              >
                                Cancel
                              </button>

                              <button
                                className="dark-border"
                                type="button"
                                onClick={() => {
                                  closeAllDropdowns();
                                  setSelectedStock(tempSelectedStock); // apply the filter
                                  setStockfilterDrawerOpen(false); // close only the filter drawer
                                }}
                              >
                                Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}
            </div>

            {instancesDrawerOpen &&
              selectedRow &&
              (() => {
                // Safely compute values here
                const pendingCount =
                  selectedRow.pending?.reduce(
                    (sum, item) => sum + item.count,
                    0
                  ) || 0;
                const total = Number(selectedRow.available || 0) + pendingCount;

                return (
                  <>
                    <div className="drawer-overlay" />
                    <div className="entity-drawer" ref={drawerRef}>
                      <div className="drawer-header">
                        <div className="d-flex align-items-center gap-1">
                          <button
                            className="back-btn"
                            onClick={() => {
                              setInstancesDrawerOpen(false);
                              setDrawerOpen(true);
                            }}
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            <ChevronLeft />
                          </button>
                          <h3>Stock Instance Info</h3>
                        </div>

                        <button
                          className="close-btn"
                          onClick={() => {
                            setInstancesDrawerOpen(false);
                          }}
                        >
                          <X size={24} />
                        </button>
                      </div>

                      <div className="main-drawer-inner">
                        <div className="drawer-title d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <img
                              src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                              alt="avatar"
                              className="avatar"
                              style={{
                                width: 40,
                                height: 40,
                                marginRight: 8,
                                verticalAlign: "middle",
                              }}
                            />
                            <h2 className="pb-0">35334107 123456 2</h2>
                          </div>
                          <div className="entities-tab flex-row align-items-center gap-3">
                            <div className="toolbar">
                              <div
                                className="toolbar-right"
                                style={{ position: "relative" }}
                                ref={toolbarRef}
                              >
                                <button
                                  className="drawer-dots"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleToolbarDropdown2();
                                  }}
                                >
                                  <MoreHorizontal size={18} />
                                </button>

                                {toolbarDropdownOpen2 && (
                                  <div
                                    className="backdrop-cls"
                                    style={{
                                      position: "absolute",
                                      top: 40,
                                      right: 0,
                                      background: "white",
                                      boxShadow: "0px 1px 4px 0px #0000001A",
                                      zIndex: 1000,
                                      minWidth: 152,
                                      borderRadius: 8,
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div className="btn-align-forall">
                                      <div className="common-for-all">
                                        <button
                                          onClick={() => {
                                            setStockoutModalOpen(true);
                                          }}
                                        >
                                          Stock Out
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="drawer-tabs">
                          <button
                            className={
                              drawerTab2 === "entity-info2" ? "active" : ""
                            }
                            onClick={() => setDrawerTab2("entity-info2")}
                          >
                            Stock Info
                          </button>
                          <button
                            className={
                              drawerTab2 === "additional-info" ? "active" : ""
                            }
                            onClick={() => setDrawerTab2("additional-info")}
                          >
                            Additional Info
                          </button>
                        </div>

                        <div className="drawer-content">
                          {drawerTab2 === "entity-info2" && (
                            <div className="tab-panel entity-info-panel">
                              <div className="field-block">
                                <div className="field-label">IMEI/Barcode</div>
                                <div className="field-value">
                                  35334107 123456 2
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Open ID</div>
                                <div className="field-value d-flex align-items-center gap-2">
                                  <span
                                    style={{
                                      color: "#2C7BE5",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                      )
                                    }
                                  >
                                    8d5815b4-38d2-405c-86c0-3366fa7cbccc
                                  </span>
                                  <Copy
                                    size={13}
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      color: "#2C7BE5",
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Status</div>
                                <div className="field-value">
                                  <span
                                    className={`status ${selectedRow.status.toLowerCase()}`}
                                  >
                                    {selectedRow.status}
                                  </span>
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">ID</div>
                                <div className="field-value">
                                  {selectedRow.iD}
                                </div>
                              </div>
                              <div className="field-block">
                                <div className="field-label">Branch</div>
                                <div className="field-value">
                                  <a
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-flex align-items-center gap-1 me-3"
                                    style={{
                                      color: "#2C7BE5",
                                      textDecoration: "underline",
                                      fontWeight: "600",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Bedok
                                    <SquareArrowOutUpRight
                                      size={14}
                                      strokeWidth={3}
                                    />
                                  </a>
                                </div>
                              </div>
                              <div className="field-block">
                                <div className="field-label">Reserved</div>
                                <div className="field-value">
                                  {selectedRow.reserved}
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Quantity</div>

                                <div
                                  className="field-value"
                                  style={{ marginBottom: "2px", gap: "4px" }}
                                >
                                  Total: {total}
                                </div>

                                <div
                                  className="field-value"
                                  style={{ marginBottom: "2px", gap: "4px" }}
                                >
                                  Available: {selectedRow.available}
                                </div>

                                <div
                                  className="field-value"
                                  style={{ gap: "4px" }}
                                >
                                  Pending: {pendingCount}
                                </div>

                                <div
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "5px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 4,
                                      maxWidth: "150px",
                                    }}
                                  >
                                    {selectedRow.pending?.map((p, i) => (
                                      <div
                                        key={i}
                                        className="field-value"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: p.color,
                                            fontSize: 14,
                                            marginRight: 6,
                                          }}
                                        >
                                          ●
                                        </span>
                                        <span style={{ marginRight: 4 }}>
                                          {p.type}
                                        </span>
                                        <span
                                          style={{
                                            marginLeft: "auto",
                                            marginRight: "8px",
                                          }}
                                        >
                                          {p.count}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                              <div className="field-block gy-3 gy-md-0 row">
                                <div className="col-md-6">
                                  <div className="field-label">
                                    First Stock In Time
                                  </div>
                                  <div className="field-value">
                                    2024-12-01 23:34
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="field-label">
                                    First Stock In Channel
                                  </div>
                                  <div className="field-value">Purchase</div>
                                </div>
                              </div>
                              <div className="field-block gy-3 gy-md-0 row">
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock In Time
                                  </div>
                                  <div className="field-value">
                                    2024-12-01 23:34
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock In Channel
                                  </div>
                                  <div className="field-value">Purchase</div>
                                </div>
                              </div>
                              <div className="field-block gy-3 gy-md-0 row">
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock Out Time
                                  </div>
                                  <div className="field-value">
                                    2024-12-01 23:34
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock Out Channel
                                  </div>
                                  <div className="field-value">Purchase</div>
                                </div>
                              </div>
                            </div>
                          )}
                          {drawerTab2 === "additional-info" && (
                            <div className="tab-panel additional-info-panel">
                              <p className="note-type-added">Note</p>
                              <label className="no-description-cls notes-preserve">
                                No Description
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}

            {stockoutModalOpen && (
              <>
                {/* Overlay backdrop */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={stockoutRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  {/* Header */}
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                      className="close-btn"
                      onClick={() => setStockoutModalOpen(false)}
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <h3
                    style={{
                      textAlign: "left",
                      color: "#212529",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "24px",
                      fontFamily: "Montserrat",
                      marginBottom: "5px",
                    }}
                  >
                    Initiate Stock Out
                  </h3>
                  {/* Subtext */}
                  <p
                    style={{
                      marginBottom: "0",
                      textAlign: "left",
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    Initiating a stock-out means marking the item as no longer
                    part of active inventory. This action only applies to cases
                    such as loss, scrap, or other non-sale or gift removals.
                  </p>

                  {/* Form Content */}
                  <div className="drawer-content">
                    <div className="row gappingcls-added">
                      <div className="col-12">
                        <div className="info-inner tab-panel">
                          <div className="field-block">
                            <div
                              className="field-label"
                              style={{
                                display: "flex",
                                gap: "4px",
                                alignItems: "center",
                              }}
                            >
                              Stock Out{" "}
                              <span
                                className="error-color"
                                style={{ color: "red" }}
                              >
                                *
                              </span>
                              <Tooltip content="Choose Stock Out">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </div>
                            <select className="form-select new-form-select-cls">
                              <option value="">Select Stock Out</option>
                              <option value="Loss">Loss</option>
                              <option value="Out">Out</option>
                            </select>
                          </div>
                          <div className="field-block">
                            <div
                              className="field-label"
                              style={{
                                display: "flex",
                                gap: "4px",
                                alignItems: "center",
                              }}
                            >
                              Quantity{" "}
                              <span
                                className="error-color"
                                style={{ color: "red" }}
                              >
                                *
                              </span>
                              <Tooltip content="Choose Quantity">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </div>

                            <div className="custom-quantity-wrapper">
                              <input
                                type="number"
                                value={quantity}
                                onChange={(e) =>
                                  setQuantity(Number(e.target.value))
                                }
                                className="custom-quantity-input"
                              />
                              <div className="custom-spinner">
                                <ChevronUp
                                  size={16}
                                  onClick={handleIncrease}
                                  className="spinner-icon"
                                />
                                <ChevronDown
                                  size={16}
                                  onClick={handleDecrease}
                                  className="spinner-icon"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="field-block">
                            <div
                              className="field-label"
                              style={{
                                display: "flex",
                                gap: "4px",
                                alignItems: "center",
                              }}
                            >
                              Reason{" "}
                              <span
                                className="error-color"
                                style={{ color: "red" }}
                              >
                                *
                              </span>
                              <Tooltip content="Choose Reason">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </div>
                            <textarea
                              className="form-control w-100 common-textarea-all"
                              id="exampleFormControlTextarea1"
                              rows="3"
                              name="Reason"
                              style={{
                                borderColor: "#6c757d",
                                borderRadius: "8px",
                                resize: "none",
                                height: "120px",
                                overflowY: "auto",
                                fontFamily: '"Montserrat", sans-serif',
                                color: "#6c757d",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "18px",
                                boxShadow: "none",
                              }}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button
                      className="btn-cancel"
                      onClick={() => setStockoutModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn-save"
                      onClick={handleStockoutConfirm}
                    >
                      Stock Out
                    </button>
                  </div>
                </div>
              </>
            )}

            {archivedModalOpen && (
              <>
                {/* Overlay backdrop */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={archivedRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  {/* Header */}
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                      className="close-btn"
                      onClick={() => setArchivedModalOpen(false)}
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <h3
                    style={{
                      textAlign: "left",
                      color: "#212529",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "24px",
                      fontFamily: "Montserrat",
                      marginBottom: "5px",
                    }}
                  >
                    Branch can’t be archived
                  </h3>
                  {/* Subtext */}
                  <p
                    style={{
                      marginBottom: "0",
                      textAlign: "left",
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    Branch stocked with items can’t be archived, clear stock
                    before archiving. Archive action is also subject to approval
                  </p>

                  {/* Footer */}
                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button
                      className="btn-save"
                      onClick={handleArchivedConfirm}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </>
            )}

            {archivedModalOpen && (
              <div ref={archivedRef}>
                <ConfirmArchiveModal
                  isOpen={archivedModalOpen}
                  onCancel={() => setArchivedModalOpen(false)}
                  onConfirm={() => handleArchiveStock(selectedArchiveStockId)}
                  entityName="Stock"
                />
              </div>
            )}

            {deactivateModalOpen && (
              <ConfirmDeactivateModal
                isOpen={deactivateModalOpen}
                onCancel={() => setDeactivateModalOpen(false)}
                onConfirm={() => {
                  handleDeactivateStock(selectedStockId);
                  // setDeactivateModalOpen(false);
                }}
                entityName="Stock"
              />
            )}

            {errorPopup.open && (
              <>
                {/* Overlay backdrop */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={archivedRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  {/* Header */}
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                      className="close-btn"
                      onClick={() =>
                        setErrorPopup({
                          open: false,
                          title: "",
                          message: "",
                        })
                      }
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <h3
                    style={{
                      textAlign: "left",
                      color: "#212529",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "24px",
                      fontFamily: "Montserrat",
                      marginBottom: "5px",
                    }}
                  >
                   {errorPopup.title || "The Stock can’t be archived"}
                  </h3>
                  {/* Subtext */}
                  <p
                    style={{
                      marginBottom: "0",
                      textAlign: "left",
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    {errorPopup.message || "There are In-Stock and Pending StockInstances under this Stock. Please stock out them first."}
                  </p>

                  {/* Footer */}
                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button
                      className="btn-save"
                      onClick={() =>
                        setErrorPopup({
                          open: false,
                          title: "",
                          message: "",
                        })
                      }
                    >
                      OK
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        {activeTab === "archived-stock" && (
          <div className="tab-content" id="archived-stock-content">
            {/* Archived Stock Card */}
            <div className="info-section">
              <div className="info-card">
                <div className="entities-tab">
                  <div className="toolbar">
                    <div className="toolbar-left">
                      <SearchBox
                        searchInput={archivedSearchInput}
                        setSearchInput={setArchivedSearchInput}
                        setSearchTerm={setArchivedSearchTerm}
                        setCurrentPage={setArchivedCurrentPage}
                        disabled={isArchivedTableEmpty}
                      />
                      <button
                        ref={archivedFilterButtonRef}
                        className={`icon-btn p-2 filter-btn ${archivedFiltersApplied ? "applied" : ""
                          }`}
                        onClick={() =>
                          !isArchivedTableEmpty &&
                          setArchivedFilterPopupOpen((prev) => !prev)
                        }
                        disabled={isArchivedTableEmpty}
                        style={{
                          border: archivedFiltersApplied
                            ? "1px solid #2C7BE5"
                            : "1px solid #6C757D",
                          color: archivedFiltersApplied ? "#2C7BE5" : "#6C757D",
                          background: isArchivedTableEmpty
                            ? "#E9ECEF"
                            : archivedFiltersApplied
                              ? "#CFE2FF"
                              : "#FFFFFF",
                          height: 40,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: isArchivedTableEmpty ? 0.6 : 1,
                          pointerEvents: isArchivedTableEmpty ? "none" : "auto",
                        }}
                      >
                        {archivedFiltersApplied ? (
                          <FilterActiveIcon />
                        ) : (
                          <FilterInactiveIcon />
                        )}
                      </button>
                    </div>
                  </div>

                  {archivedFilterPopupOpen && (
                    <>
                      {/* Overlay */}
                      <div
                        onClick={handleArchivedCloseFilterPopup}
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100vh",
                          backgroundColor: "rgba(0,0,0,0.4)",
                          zIndex: 1500,
                        }}
                      />

                      {/* Drawer */}
                      <div
                        ref={archivedFilterPopupRef}
                        style={{
                          position: "fixed",
                          top: 0,
                          right: 0,
                          width: 360,
                          height: "100vh",
                          backgroundColor: "#FFFFFF",
                          boxShadow: "-3px 0 12px rgba(0,0,0,0.1)",
                          zIndex: 2000,
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden",
                        }}
                      >
                        {/* ================= HEADER ================= */}
                        <div
                          style={{
                            height: 60,
                            padding: "15px 20px",
                            background: "#F8F9FA",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #E9ECEF",
                          }}
                        >
                          <h4
                            style={{
                              margin: 0,
                              fontSize: 14,
                              fontWeight: 600,
                              fontFamily: "Montserrat",
                              color: "#212529",
                            }}
                          >
                            Filter
                          </h4>

                          <button
                            onClick={handleArchivedCloseFilterPopup}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            <X size={18} />
                          </button>
                        </div>

                        {/* ================= BODY (SCROLLABLE) ================= */}
                        <div
                          style={{
                            flex: 1,
                            overflowY: "auto",
                            paddingBottom: 16,
                          }}
                        >
                          {/* -------- Condition L1 -------- */}
                          <div
                            ref={archivedConditionL1Ref}
                            className="position-relative"
                            style={{ padding: "5px 20px 0 20px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontStyle: "normal",
                                lineHeight: "normal",
                              }}
                            >
                              Condition L1
                            </label>

                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setArchivedConditionL1Open(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {archivedTempConditionL1.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontSize:12
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleArchivedConditionL1(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {archivedTempConditionL1.length === 0 && (
                                <span
                                  style={{
                                    color: "#6C757D",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat",
                                    userSelect: "none",
                                  }}
                                >
                                  Select...
                                </span>
                              )}

                              {/* Dropdown icon */}
                              <span
                                onClick={toggleArchivedConditionL1Dropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {archivedConditionL1Open ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {archivedConditionL1Open && (
                              <div
                                className="dropdown-menu show"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {archivedFilteredConditionL1.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {archivedFilteredConditionL1.map((item) => {
                                  const isSelected =
                                    archivedTempConditionL1.includes(item);

                                  return (
                                    <div
                                      key={item}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() =>
                                        toggleArchivedConditionL1(item)
                                      }
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529',
                                        fontSize:14
                                      }}
                                    >
                                      <span>{item}</span>

                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* -------- Condition L2 -------- */}
                          <div
                            ref={archivedConditionL2Ref}
                            className="position-relative mt-2"
                            style={{ padding: "5px 20px 0 20px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontStyle: "normal",
                                lineHeight: "normal",
                              }}
                            >
                              Condition L2
                            </label>

                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setArchivedConditionL2Open(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {archivedTempConditionL2.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontSize:12
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleArchivedConditionL2(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {archivedTempConditionL2.length === 0 && (
                                <span
                                  style={{
                                    color: "#6C757D",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat",
                                    userSelect: "none",
                                  }}
                                >
                                  Select...
                                </span>
                              )}

                              {/* Dropdown icon */}
                              <span
                                onClick={toggleArchivedConditionL2Dropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {archivedConditionL2Open ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {archivedConditionL2Open && (
                              <div
                                className="dropdown-menu show"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {archivedFilteredConditionL2.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results.
                                  </div>
                                )}

                                {archivedFilteredConditionL2.map((item) => {
                                  const isSelected =
                                    archivedTempConditionL2.includes(item);

                                  return (
                                    <div
                                      key={item}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() =>
                                        toggleArchivedConditionL2(item)
                                      }
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529',
                                        fontSize:14
                                      }}
                                    >
                                      <span>{item}</span>

                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* -------- Brand -------- */}
                          <div
                            ref={archivedBrandRef}
                            className="position-relative"
                            style={{ padding: "5px 21px 0 21px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontStyle: "normal",
                                lineHeight: "normal",
                              }}
                            >
                              Brand
                            </label>

                            {/* Input + Tags */}
                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setArchivedBrandsOpen(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {archivedTempBrands.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleArchivedBrands(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {/* Search input */}
                              <input
                                type="text"
                                value={archivedBrandSearch}
                                onChange={(e) => {
                                  setArchivedBrandSearch(e.target.value);
                                  setArchivedBrandsOpen(true);
                                }}
                                placeholder={
                                  archivedTempBrands.length === 0
                                    ? "Select or Search..."
                                    : ""
                                }
                                style={{
                                  border: "none",
                                  outline: "none",
                                  flex: 1,
                                  minWidth: 60,
                                  background: "transparent",
                                  fontSize:14,
                                  fontWeight:400
                                }}
                              />

                              {/* Dropdown icon */}
                              <span
                                onClick={toggleArchivedBrandDropdown}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {archivedBrandsOpen ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {/* Dropdown */}
                            {archivedBrandsOpen && (
                              <div
                                className="dropdown-menu show mt-1"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {archivedFilteredBrands.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {archivedFilteredBrands.map((item) => {
                                  const isSelected =
                                    archivedTempBrands.includes(item.name);

                                  return (
                                    <div
                                      key={item.id}
                                      className="dropdown-item d-flex align-items-center justify-content-between"
                                      onClick={() => {
                                        toggleArchivedBrands(item.name);
                                        setArchivedBrandSearch("");
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        backgroundColor: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        padding: "8px 12px",
                                        color:'#212529',
                                        fontSize:14
                                      }}
                                    >
                                      {/* left side: image + name */}
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 8,
                                        }}
                                      >
                                        <img
                                          src={item.image}
                                          alt={item.name}
                                          style={{
                                            width: 24,
                                            height: 24,
                                            objectFit: "contain",
                                            borderRadius: 4,
                                            background: "#fff",
                                            flexShrink: 0,
                                          }}
                                          onError={(e) => {
                                            e.target.src =
                                              "/images/brand-placeholder.png";
                                          }}
                                        />

                                        <span
                                          style={{
                                            fontFamily: "Montserrat",
                                            fontSize: "14px",
                                            color: "#212529",
                                          }}
                                        >
                                          {item.name}
                                        </span>
                                      </div>

                                      {/* right side: check */}
                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* -------- Category -------- */}
                          <div
                            ref={archivedCategoryRef}
                            className="position-relative"
                            style={{ padding: "5px 21px 0 21px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                              }}
                            >
                              Category
                            </label>

                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setArchivedCategoriesOpen(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {archivedTempCategories.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleArchivedCategories(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              <input
                                type="text"
                                value={archivedCategorySearch}
                                onChange={(e) => {
                                  setArchivedCategorySearch(e.target.value);
                                  setArchivedCategoriesOpen(true);
                                }}
                                placeholder={
                                  archivedTempCategories.length === 0
                                    ? "Select or Search..."
                                    : ""
                                }
                                style={{
                                  border: "none",
                                  outline: "none",
                                  flex: 1,
                                  minWidth: 60,
                                  background: "transparent",
                                  fontSize:14,
                                  fontWeight:400
                                }}
                              />

                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setArchivedCategoriesOpen((prev) => !prev);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {archivedCategoriesOpen ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {archivedCategoriesOpen && (
                              <div
                                className="dropdown-menu show mt-1"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {archivedFilteredCategories.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {archivedFilteredCategories.map((item) => {
                                  const isSelected =
                                    archivedTempCategories.includes(item.name);

                                  return (
                                    <div
                                      key={item.id}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() => {
                                        toggleArchivedCategories(item.name);
                                        setArchivedCategorySearch("");
                                      }}
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529',
                                        fontSize:14
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          width: "100%",
                                        }}
                                      >
                                        {/* Left text */}
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "4px",
                                          }}
                                        >
                                          {/* Parent category */}
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: 400,
                                              fontFamily: "Montserrat",
                                              color: "#212529",
                                            }}
                                          >
                                            {item.name}
                                          </span>

                                          {/* Parent Parent >> Parent */}
                                          {item.parent_name && item.name && (
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                fontFamily: "Montserrat",
                                                color: "#6C757D",
                                              }}
                                            >
                                              {item.parent_name} {" >> "}{" "}
                                              {item.name}
                                            </span>
                                          )}
                                        </div>

                                        {/* Selected check */}
                                        {isSelected && (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                          >
                                            <path
                                              d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                              stroke="#6C757D"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>

                          {/* -------- Type -------- */}
                          <div
                            ref={archivedTypeRef}
                            className="position-relative"
                            style={{ padding: "5px 21px 0 21px" }}
                          >
                            <label
                              className="fw-semibold mb-1 mt-1"
                              style={{
                                fontWeight: 600,
                                marginBottom: "8px",
                                color: "#212529",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                              }}
                            >
                              Type
                            </label>

                            <div
                              className="form-control d-flex flex-wrap align-items-center gap-1"
                              onClick={() => setArchivedTypesOpen(true)}
                              style={{ minHeight: 38, cursor: "text", height:40 }}
                            >
                              {archivedTempTypes.map((item) => (
                                <span
                                  key={item}
                                  className="badge d-flex align-items-center"
                                  style={{
                                    background: "#FFEB00",
                                    color: "#212529",
                                    padding: "5px",
                                    fontWeight: 600,
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item}
                                  <span
                                    style={{ cursor: "pointer", marginLeft: 4, fontSize:12 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleArchivedTypes(item);
                                    }}
                                  >
                                    ×
                                  </span>
                                </span>
                              ))}

                              {archivedTempTypes.length === 0 && (
                                <span
                                  style={{
                                    color: "#6C757D",
                                    fontSize: "14px",
                                    fontFamily: "Montserrat",
                                    userSelect: "none",
                                  }}
                                >
                                  Select...
                                </span>
                              )}

                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setArchivedTypesOpen((prev) => !prev);
                                }}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "auto",
                                }}
                              >
                                {archivedTypesOpen ? (
                                  <ChevronUp size={16} />
                                ) : (
                                  <ChevronDown size={16} />
                                )}
                              </span>
                            </div>

                            {archivedTypesOpen && (
                              <div
                                className="dropdown-menu show mt-1"
                                style={{
                                  maxHeight: 200,
                                  overflowY: "auto",
                                  width: "92%",
                                  margin: "0 0 0 15px",
                                }}
                              >
                                {archivedFilteredTypes.length === 0 && (
                                  <div className="dropdown-item text-muted">
                                    No results
                                  </div>
                                )}

                                {archivedFilteredTypes.map((item) => {
                                  const isSelected =
                                    archivedTempTypes.includes(item);

                                  return (
                                    <div
                                      key={item}
                                      className="dropdown-item d-flex justify-content-between"
                                      onClick={() => toggleArchivedTypes(item)}
                                      style={{
                                        background: isSelected
                                          ? "#FFF8CC"
                                          : "transparent",
                                        fontWeight: isSelected ? 400 : 400,
                                        cursor: "pointer",
                                        color:'#212529',
                                        fontSize:14
                                      }}
                                    >
                                      <span>{item}</span>
                                      {isSelected && (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                            stroke="#6C757D"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ================= FOOTER (FIXED BOTTOM) ================= */}
                        <div
                          style={{
                            padding: "16px",
                            background: "#FFFFFF",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {/* Clear */}
                          <button
                            onClick={handleClearArchivedFilters}
                            style={{
                              background: "none",
                              border: "none",
                              fontFamily: "Montserrat",
                              fontSize: 12,
                              fontWeight: 600,
                              color: "#000",
                              cursor: "pointer",
                            }}
                          >
                            Clear
                          </button>

                          {/* Right buttons */}
                          <div style={{ display: "flex", gap: 8 }}>
                            <button
                              onClick={handleArchivedCloseFilterPopup}
                              style={{
                                height: 34,
                                minWidth: 100,
                                borderRadius: 8,
                                border: "1px solid #212529",
                                background: "#FFFFFF",
                                fontFamily: "Montserrat",
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              Cancel
                            </button>

                            <button
                              onClick={handleApplyArchivedFilters}
                              style={{
                                height: 34,
                                minWidth: 100,
                                borderRadius: 8,
                                border: "none",
                                background: "#212529",
                                color: "#FFFFFF",
                                fontFamily: "Montserrat",
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                            >
                              Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* archived stock list table */}
                  <div className="table-wrapper">
                    <div className={activeTab === "stock-list" ? "stock-wrapper" : "archived-wrapper"}>
                      <DynamicTable
                        columns={archivedColumns}
                        data={archivedPageData}
                        sortField={archivedSortConfig.key}
                        sortOrder={archivedSortConfig.direction}
                        handleSort={handleArchivedSort}
                        onRowClick={onRowClick}
                        onActionClick={(id) => toggleArchivedDropdown(id)}
                        noImage={noImage}
                        selectedIds={selectedIds}
                        dropdownOpenId={archivedDropdownOpenId}
                        suppressHighlight={suppressHighlight}
                        buttonRefs={archivedButtonRefs}
                        rowKey="id"
                        searchTerm={archivedSearchTerm}
                        selectedStatuses={selectedStatuses}
                        selectedParentBrands={""}
                        emptyImage={emptyImage}
                        emptyTitle={emptyTitle}
                        emptyMessage={emptyMessage}
                        showActions={true}
                      />
                    </div>
                  </div>
                  {archivedDropdownOpenId !== null && (
                    <div
                      ref={dropdownRef}
                      className="backdrop-cls"
                      style={{
                        position: "absolute",
                        top: archivedDropdownPosition.top,
                        left: archivedDropdownPosition.left,
                        background: "white",
                        boxShadow: "0px 1px 4px 0px #0000001A",
                        zIndex: 1000,
                        minWidth: 152,
                        borderRadius: 8,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="btn-align-forall">
                        <div className="common-for-all">
                          <button
                            onClick={() => {
                              const row = archivedPageData.find(
                                (d) => d.id === archivedDropdownOpenId
                              );
                              onRowClick(row);
                              setDropdownOpenId(null);
                            }}
                          >
                            View Stock Details
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="pagination">
                    <div className="pagination-info">
                      {`${(archivedCurrentPage - 1) * PAGE_SIZE + 1
                        } - ${Math.min(
                          archivedCurrentPage * PAGE_SIZE,
                          archivedFiltered.length
                        )} of ${archivedFiltered.length}`}
                    </div>

                    <Pagination
                      currentPage={archivedCurrentPage}
                      totalPages={archivedTotalPages}
                      onPageChange={setArchivedCurrentPage}
                    />
                  </div>
                  {saveModalOpen && (
                    <>
                      <div className="drawer-overlay" />
                      <div
                        className="entity-drawer modal-popup-cls"
                        ref={saveRef}
                        style={{
                          maxWidth: 650,
                          margin: "0 auto",
                          background: "white",
                          borderRadius: 12,
                          zIndex: 1050,
                          padding: 24,
                          position: "fixed",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          height: "auto",
                          right: "auto",
                          overflow: "inherit",
                        }}
                      >
                        <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                          <button
                            className="close-btn"
                            onClick={() => setSaveModalOpen(false)}
                          >
                            <X size={20} />
                          </button>
                        </div>
                        <h3
                          style={{
                            textAlign: "left",
                            color: "#212529",
                            fontSize: "20px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            fontFamily: "Montserrat",
                            marginBottom: "5px",
                          }}
                        >
                          New feature in Progress
                        </h3>
                        <p
                          style={{
                            marginBottom: "0",
                            textAlign: "left",
                            color: "#6C757D",
                            fontSize: "14px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontFamily: "Montserrat",
                          }}
                        >
                          Work in Progress
                        </p>
                        <div
                          className="drawer-footer"
                          style={{ paddingTop: "10px" }}
                        >
                          <button
                            className="btn-save"
                            onClick={handleSaveConfirm}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Single‐row Drawer (unchanged) */}
            <div className="drawer-container" ref={drawerContainerRef}>
              {/* Single‐row Drawer (unchanged) */}
              {drawerOpen &&
                selectedRow &&
                (() => {
                  const pendingCount =
                    selectedRow.pending?.reduce(
                      (sum, item) => sum + item.count,
                      0
                    ) || 0;
                  const total =
                    Number(selectedRow.available || 0) + pendingCount;
                  return (
                    <>
                      <div className="drawer-overlay main-drawer-overlay" />
                      <div className="entity-drawer" ref={drawerRef}>
                        <div
                          className="drawer-header"
                          style={{ backgroundColor: "#F8F9FA" }}
                        >
                          <h3>Stock Info</h3>
                          <button
                            className="close-btn"
                            onClick={() => {
                              setDrawerOpen(false);
                              setSelectedIds((ids) =>
                                ids.filter((id) => id !== selectedRow?.id)
                              );
                              setSelectedRow(null);
                            }}
                          >
                            <X size={24} />
                          </button>
                        </div>
                        {/* info drawer */}
                        <div className="main-drawer-inner">
                          <div className="drawer-title d-flex align-items-center justify-content-between">
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "8px" }}
                            >
                              <img
                                src={selectedRow.avatar}
                                alt="avatar"
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 6,
                                  objectFit: "cover",
                                  flexShrink: 0,
                                }}
                              />

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                {/* Title */}
                                <span
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "#212529",
                                    lineHeight: "18px",
                                  }}
                                >
                                  {selectedRow?.name}
                                </span>

                                {/* Subtitle */}
                                <span
                                  style={{
                                    fontFamily: "Montserrat",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "#6C757D",
                                    lineHeight: "16px",
                                  }}
                                >
                                  {selectedRow?.variant}
                                </span>
                              </div>
                            </div>
                            <div className="entities-tab flex-row align-items-center gap-3">
                      
                            </div>
                          </div>

                          <div className="drawer-tabs">
                            <button
                              className={
                                drawerTab === "entity-info" ? "active" : ""
                              }
                              onClick={() => setDrawerTab("entity-info")}
                            >
                              General
                            </button>
    
                            <button
                              className={
                                drawerTab === "additional-info" ? "active" : ""
                              }
                              onClick={() => setDrawerTab("additional-info")}
                            >
                              Additional
                            </button>
                          </div>

                          <div className="drawer-content">
                            {drawerTab === "entity-info" && (
                              <div className="tab-panel entity-info-panel">
                                {/*Stock Summary Cards*/}
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    marginTop: "16px",
                                  }}
                                ></div>

                                {/* Basic Info in info drawer */}
                                {/* Title */}
                                <div
                                  style={{
                                    marginTop: "10px",
                                    border: "1px solid #E9ECEF",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    background: "#fff",
                                  }}
                                >
                                  {/* Header */}
                                  <div
                                    style={{
                                      backgroundColor: "#F8F9FA",
                                      padding: "15px 20px",
                                      fontSize: 14,
                                      fontWeight: 600,
                                      color: "#212529",
                                    }}
                                  >
                                    Basic Info
                                  </div>

                                  {/* Body */}
                                  <div
                                    style={{
                                      padding: "16px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        columnGap: 24,
                                        rowGap: 16,
                                        fontSize: 12,
                                        color: "#212529",
                                      }}
                                    >
                                      {/* SPU & SKU */}
                                      <div style={{
                                        gridColumn: "1 / -1",   // THIS is the fix
                                      }}>
                                        <div
                                          style={{
                                            fontWeight: 700,
                                            marginBottom: 10,
                                          }}
                                        >
                                          SPU & SKU
                                        </div>

                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            maxWidth: "100%",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {/* Avatar */}
                                          <img
                                            src={selectedRow.avatar}
                                            alt=""
                                            style={{
                                              width: 32,
                                              height: 32,
                                              borderRadius: 4,
                                              flexShrink: 0,
                                            }}
                                          />

                                          {/* Text */}
                                          <span
                                            style={{
                                              fontWeight: 600,
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              flex: 1, // 🔑 takes remaining space
                                            }}
                                            title={`${selectedRow.name} ${selectedRow.variant}`}
                                          >
                                            {selectedRow.name}{" "}
                                            {selectedRow.variant}
                                          </span>
                                        </div>
                                      </div>


                                      {/* Condition L1 */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Condition L1
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.condition}
                                        </span>
                                      </div>

                                      {/* Condition L2 */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Condition L2
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.grading}
                                        </span>
                                      </div>

                                      {/* Type */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Type
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.type}
                                        </span>
                                      </div>

                                      {/* Brand */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Brand
                                        </div>
                                        <div>{selectedRow.brand}</div>
                                      </div>

                                      {/* Category */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Category
                                        </div>
                                        <div>{selectedRow.category}</div>
                                      </div>
                                      <div></div>

                                      {/* ID */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          ID
                                        </div>
                                        <div>{selectedRow.id}</div>
                                      </div>

                                      {/* Open ID */}
                                      <div style={{ gridColumn: "1 / -1" }}>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Open ID
                                        </div>

                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 6,
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {/* Open ID text */}
                                          <span
                                            style={{
                                              color: "#2C7BE5",
                                              cursor: "pointer",
                                              textDecoration: "underline",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              maxWidth: 420, // ✅ keeps single line
                                              flexShrink: 1,
                                            }}
                                            title={selectedRow.openId || "—"}
                                            onClick={() =>
                                              // navigator.clipboard.writeText(selectedRow.openId)
                                              navigator.clipboard.writeText(
                                                selectedRow.openId || "—"
                                              )
                                            }
                                          >
                                            {/* {selectedRow.openId} */}
                                            {selectedRow.openId || "—"}
                                          </span>

                                          {/* Copy icon + tooltip anchor */}
                                          <span
                                            style={{
                                              position: "relative", // ✅ anchor for tooltip
                                              display: "inline-flex",
                                              alignItems: "center",
                                              flexShrink: 0,
                                            }}
                                            onClick={() => {
                                              // navigator.clipboard.writeText(selectedRow.openId);
                                              navigator.clipboard.writeText(
                                                selectedRow.openId || "—"
                                              );
                                              setCopied(true);
                                              setTimeout(
                                                () => setCopied(false),
                                                1200
                                              );
                                            }}
                                          >
                                            <Copy
                                              size={14}
                                              style={{
                                                color: "#2C7BE5",
                                                cursor: "pointer",
                                              }}
                                            />

                                            {/* ✅ Tooltip (NOT clipped now) */}
                                            {copied && (
                                              <span
                                                style={{
                                                  position: "absolute",
                                                  top: "-28px",
                                                  left: "50%",
                                                  transform: "translateX(-50%)",
                                                  background: "#212529",
                                                  color: "#fff",
                                                  fontSize: 10,
                                                  padding: "4px 8px",
                                                  borderRadius: 6,
                                                  whiteSpace: "nowrap",
                                                  boxShadow:
                                                    "0px 2px 6px rgba(0,0,0,0.15)",
                                                  zIndex: 9999,
                                                }}
                                              >
                                                Copied
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      </div>

                                      {/* Created By */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Created By
                                        </div>
                                        <div>
                                          {selectedRow.createdBy || "NA"}
                                        </div>
                                      </div>

                                      {/* Created Time */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Created Time
                                        </div>
                                        <div>{selectedRow.createdAt}</div>
                                      </div>

                                      {/* Last Modified By */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Last Modified By
                                        </div>
                                        <div>
                                          <div>
                                            {selectedRow.modifiedBy || "NA"}
                                          </div>
                                        </div>
                                      </div>

                                      {/* Last Modified Time */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Last Modified Time
                                        </div>
                                        <div>
                                          {selectedRow.lastModifiedTime}
                                        </div>
                                      </div>

                                      {/* Created By */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Archived By
                                        </div>
                                        <div>
                                          {selectedRow.archivedBy || "NA"}
                                        </div>
                                      </div>

                                      {/* Created Time */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Archived Time
                                        </div>
                                        <div>{selectedRow.archived_time}</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {drawerTab === "stock-instances" && (
                              <div className="tab-panel stock-instances-panel">
                                <div
                                  className="entities-tab"
                                  style={{ padding: 0, paddingTop: "20px" }}
                                >
                                  <div className="toolbar">
                                    <div className="toolbar-left">
                                      <div className="search-box">
                                        <Search size={20} />
                                        <input
                                          type="text"
                                          placeholder="Search…"
                                          value={imeiSearchInput}
                                          onChange={(e) => {
                                            setImeiSearchInput(e.target.value);
                                            setPageInView(1); // reset pagination if needed
                                          }}
                                        />
                                      </div>
                                      <button
                                        className="icon-btn"
                                        onClick={() => {
                                          setTempSelectedStock(selectedStock);
                                          setStockfilterDrawerOpen(true);
                                        }}
                                      >
                                        <Funnel size={18} /> Filter
                                        {selectedStock.length > 0 && (
                                          <span
                                            style={{
                                              background: "#212529",
                                              color: "#fff",
                                              borderRadius: "50%",
                                              fontSize: "12px",
                                              width: 20,
                                              height: 20,
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              marginLeft: 6,
                                            }}
                                          >
                                            {selectedStock.length}
                                          </span>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                  <div className="row gy-3 gy-md-0">
                                    <div className="col-md-4 d-flex">
                                      <div
                                        style={{
                                          border: "1px solid #DEE2E6",
                                          borderRadius: 8,
                                          padding: 10,
                                          textAlign: "right",
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          Reserved
                                        </p>
                                        <h6
                                          style={{
                                            fontSize: 28,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                            marginBottom: 0,
                                            marginTop: "auto",
                                          }}
                                        >
                                          {imeiStats.reserved}
                                        </h6>
                                      </div>
                                    </div>
                                    <div className="col-md-4 d-flex">
                                      <div
                                        style={{
                                          border: "1px solid #DEE2E6",
                                          borderRadius: 8,
                                          padding: 10,
                                          textAlign: "right",
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          Available
                                        </p>
                                        <h6
                                          style={{
                                            fontSize: 28,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                            marginBottom: 0,
                                            marginTop: "auto",
                                          }}
                                        >
                                          {imeiStats.available}
                                        </h6>
                                      </div>
                                    </div>
                                    <div className="col-md-4 d-flex">
                                      <div
                                        style={{
                                          border: "1px solid #DEE2E6",
                                          borderRadius: 8,
                                          padding: 10,
                                          textAlign: "right",
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontSize: 14,
                                            fontWeight: 600,
                                            color: "#212529",
                                            fontFamily:
                                              "Montserrat, sans-serif",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          Pending
                                        </p>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          {Object.entries(
                                            imeiStats.pendingTotals
                                          ).map(([type, data]) => (
                                            <div
                                              key={type}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                fontSize: 11,
                                              }}
                                            >
                                              <span
                                                style={{
                                                  color: data.color,
                                                  fontSize: 14,
                                                  marginRight: 6,
                                                }}
                                              >
                                                ●
                                              </span>
                                              <span
                                                style={{
                                                  color: "#6C757D",
                                                  marginRight: 8,
                                                }}
                                              >
                                                {type}
                                              </span>
                                              <span
                                                style={{
                                                  marginLeft: "auto",
                                                  color: "#212529",
                                                }}
                                              >
                                                {data.count}
                                              </span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="table-wrapper">
                                    <table
                                      className="entities-table"
                                      ref={tableRef}
                                      style={{ minWidth: "unset" }}
                                    >
                                      <thead>
                                        <tr>
                                          <th>
                                            <span>
                                              IMEI/Barcode{" "}
                                              <ChevronsUpDown size={10} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Branch{" "}
                                              <ChevronsUpDown size={10} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Reserved{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Available{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th>
                                            <span>
                                              Pending{" "}
                                              <ChevronsUpDown size={12} />
                                            </span>
                                          </th>
                                          <th
                                            className="sticky-action-col"
                                            style={{ textAlign: "center" }}
                                          >
                                            Action
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {visibleImeiRows.map((item, idx) => (
                                          <tr
                                            key={idx}
                                            className={
                                              idx % 2 === 1 ? "striped" : ""
                                            }
                                          >
                                            <td className="py-3">
                                              <a
                                                href="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="d-flex align-items-center gap-1 me-3"
                                                style={{
                                                  color: "#2C7BE5",
                                                  textDecoration: "underline",
                                                  fontWeight: "600",
                                                  fontSize: "12px",
                                                }}
                                              >
                                                {item.imei}
                                                <SquareArrowOutUpRight
                                                  size={14}
                                                  strokeWidth={3}
                                                />
                                              </a>
                                            </td>
                                            <td className="py-3">
                                              {item.location}
                                            </td>
                                            <td>{item.reserved}</td>
                                            <td>{item.available}</td>
                                            <td>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  gap: 4,
                                                }}
                                              >
                                                {item.pending.map((p, i) => (
                                                  <div
                                                    key={i}
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      fontSize: 11,
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: p.color,
                                                        fontSize: 14,
                                                        marginRight: 6,
                                                      }}
                                                    >
                                                      ●
                                                    </span>
                                                    <span
                                                      style={{
                                                        color: "#6C757D",
                                                        marginRight: 8,
                                                      }}
                                                    >
                                                      {p.type}
                                                    </span>
                                                    <span
                                                      style={{
                                                        marginLeft: "auto",
                                                        marginRight: "8px",
                                                      }}
                                                    >
                                                      {p.count}
                                                    </span>
                                                  </div>
                                                ))}
                                              </div>
                                            </td>

                                            <td
                                              className="sticky-action-col"
                                              style={{
                                                textAlign: "center",
                                                position: "relative",
                                              }}
                                            >
                                              <button
                                                className="icon-btn"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setImeiDropdownOpenId(
                                                    (prevId) =>
                                                      prevId === item.id
                                                        ? null
                                                        : item.id
                                                  );
                                                }}
                                              >
                                                <MoreHorizontal size={20} />
                                              </button>

                                              {imeiDropdownOpenId ===
                                                item.id && (
                                                  <div
                                                    className="backdrop-cls"
                                                    style={{
                                                      position: "absolute",
                                                      top: "40px",
                                                      right: "0",
                                                      background: "white",
                                                      boxShadow:
                                                        "0px 1px 4px 0px #0000001A",
                                                      zIndex: 1000,
                                                      minWidth: 152,
                                                      borderRadius: 8,
                                                    }}
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                  >
                                                    <div className="btn-align-forall">
                                                      <div className="common-for-all">
                                                        <button className="deactivate-cls">
                                                          Stock Out
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                            </td>
                                          </tr>
                                        ))}
                                        {visibleImeiRows.length === 0 && (
                                          <tr>
                                            <td
                                              colSpan="5"
                                              className="py-3 text-center"
                                            >
                                              No results.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            )}
                            {drawerTab === "configuration" && (
                              <div style={{ paddingTop: 10 }}>
                                {/* ===== BASIC INFO CARD ===== */}
                                <div
                                  style={{
                                    border: "1px solid #E9ECEF",
                                    borderRadius: 12,
                                    background: "#fff",
                                    marginBottom: 16,
                                    overflow: "hidden",
                                  }}
                                >
                                  {/* Header */}
                                  <div
                                    style={{
                                      background: "#F8F9FA",
                                      padding: "15px 20px",
                                      fontSize: 13,
                                      fontWeight: 600,
                                    }}
                                  >
                                    Basic Info
                                  </div>

                                  {/* Body */}
                                  <div style={{ padding: 16 }}>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        columnGap: 24,
                                        rowGap: 16,
                                        fontSize: 12,
                                      }}
                                    >
                                      {/* Spec Name */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Spec Name
                                        </div>
                                        <div>{selectedRow.name}</div>
                                      </div>

                                      {/* SKU Code */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          SKU Code
                                        </div>
                                        <div>{selectedRow.sku_code}</div>
                                      </div>

                                      {/* Enable */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Enable
                                        </div>
                                        <span
                                          style={{
                                            background: "#D1FADF",
                                            color: "#027A48",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          YES
                                        </span>
                                      </div>

                                      {/* Color */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Color
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.variant?.split(",")[0] ||
                                            "—"}
                                        </span>
                                      </div>

                                      {/* RAM */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          RAM
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          8G
                                        </span>
                                      </div>

                                      {/* Storage */}
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Storage
                                        </div>
                                        <span
                                          style={{
                                            background: "#FFE70E",
                                            padding: "2px 10px",
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {selectedRow.variant
                                            ?.split(",")[1]
                                            ?.trim() || "—"}
                                        </span>
                                      </div>

                                      {/* Open ID (FULL WIDTH) */}
                                      <div style={{ gridColumn: "1 / -1" }}>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          Open ID
                                        </div>

                                        <div
                                          style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            position: "relative",
                                            maxWidth: "100%",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: "#2C7BE5",
                                              cursor: "pointer",
                                              textDecoration: "underline",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: 420,
                                            }}
                                            // title={selectedRow.openId}
                                            title={
                                              "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                            }
                                          >
                                            {/* {selectedRow.openId} */}
                                            {
                                              "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                            }
                                          </span>

                                          <span
                                            style={{
                                              position: "relative",
                                              display: "inline-flex",
                                            }}
                                            onClick={() => {
                                              // navigator.clipboard.writeText(selectedRow.openId);
                                              navigator.clipboard.writeText(
                                                "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                              );
                                              setCopied(true);
                                              setTimeout(
                                                () => setCopied(false),
                                                1200
                                              );
                                            }}
                                          >
                                            <Copy
                                              size={14}
                                              style={{
                                                color: "#2C7BE5",
                                                cursor: "pointer",
                                              }}
                                            />

                                            {copied && (
                                              <span
                                                style={{
                                                  position: "absolute",
                                                  top: "-26px",
                                                  left: "50%",
                                                  transform: "translateX(-50%)",
                                                  background: "#212529",
                                                  color: "#fff",
                                                  fontSize: 10,
                                                  padding: "4px 8px",
                                                  borderRadius: 6,
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                Copied
                                              </span>
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* ===== BUSINESS INFO CARD ===== */}
                                <div
                                  style={{
                                    border: "1px solid #E9ECEF",
                                    borderRadius: 12,
                                    background: "#fff",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      background: "#F8F9FA",
                                      padding: "10px 16px",
                                      fontSize: 13,
                                      fontWeight: 600,
                                    }}
                                  >
                                    Business Info
                                  </div>

                                  <div style={{ padding: 16 }}>
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        columnGap: 24,
                                        rowGap: 16,
                                        fontSize: 12,
                                      }}
                                    >
                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          GTIN
                                        </div>
                                        <div>8887654109728</div>
                                      </div>

                                      <div>
                                        <div
                                          style={{
                                            fontWeight: 600,
                                            marginBottom: 6,
                                          }}
                                        >
                                          MSRP
                                        </div>
                                        <div>SGD 1,038.00</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {drawerTab === "additional-info" && (
                              <div style={{ paddingTop: 10 }}>
                                {/* ===== BASIC INFO CARD ===== */}
                                <div
                                  style={{
                                    border: "1px solid #E9ECEF",
                                    borderRadius: 12,
                                    background: "#fff",
                                    marginBottom: 16,
                                    overflow: "hidden",
                                  }}
                                >
                                  {/* Header */}
                                  <div
                                    style={{
                                      background: "#F8F9FA",
                                      padding: "10px 16px",
                                      fontSize: 13,
                                      fontWeight: 600,
                                    }}
                                  >
                                    Notes
                                  </div>

                                  {/* Body */}
                                  <div style={{ padding: 16 }}>
                                    <div
                                      style={{
                                        fontSize: 12,
                                      }}
                                    >
                                      {/* Spec Name */}
                                      <div>
                                        <div>
                                          {selectedRow.sku_notes
                                            ? selectedRow.sku_notes
                                            : "NA"}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}

              {stockfilterDrawerOpen &&
                (() => {
                  return (
                    <>
                      <div
                        className="drawer-overlay filter-drawer-overlay"
                        onMouseDown={(e) => {
                          // stop event from reaching document click handlers (so main drawer doesn't close)
                          e.stopPropagation();
                          closeAllDropdowns();
                          setStockfilterDrawerOpen(false); // clicking overlay closes only the filter drawer
                        }}
                      />

                      <div className="filter-drawer" ref={filterDrawerRef}>
                        <div className="drawer-header">
                          <div className="d-flex align-items-center gap-1">
                            <h3>Filter</h3>
                          </div>

                          <button
                            className="close-btn"
                            onClick={() => {
                              closeAllDropdowns();
                              setStockfilterDrawerOpen(false); // just close the filter drawer, leave main drawer as-is
                            }}
                          >
                            <X size={24} />
                          </button>
                        </div>
                        <div className="main-company-body-inner d-flex flex-column h-100">
                          <div className="main-drawer-inner">
                            {/* ─── ROW 1: Branch ─────────────────────────────────────── */}
                            <div className="row gappingcls-added">
                              <div className="col-12">
                                <div
                                  className="info-inner"
                                  ref={stockRef}
                                  style={{ position: "relative" }}
                                >
                                  <label className="form-label d-flex align-items-center gap-2">
                                    Branch
                                  </label>

                                  {/* CLOSED VIEW: tags + arrow */}
                                  <div
                                    className="select-box form-control common-input-all"
                                    onClick={toggleStock}
                                    style={{
                                      padding: "0.5rem",
                                      minHeight: "40px",
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "wrap",
                                      position: "relative",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {tempSelectedStock.length > 0 ? (
                                      tempSelectedStock.map((d) => (
                                        <span
                                          key={d.value}
                                          className="tag"
                                          style={{
                                            backgroundColor: "#FFEB00",
                                            color: "#212529",
                                            borderRadius: "16px",
                                            padding: "4px 8px",
                                            margin: "2px",
                                            display: "flex",
                                            alignItems: "center",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            lineHeight: "normal",
                                          }}
                                        >
                                          {d.label}
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setTempSelectedStock((prev) =>
                                                prev.filter(
                                                  (item) =>
                                                    item.value !== d.value
                                                )
                                              );
                                            }}
                                            style={{
                                              background: "none",
                                              border: "none",
                                              marginLeft: "20px",
                                              cursor: "pointer",
                                              fontSize: "16px",
                                              padding: "0",
                                              lineHeight: "14px",
                                            }}
                                          >
                                            <X size={14} strokeWidth={3} />
                                          </button>
                                        </span>
                                      ))
                                    ) : (
                                      <span
                                        style={{
                                          color: "#999",
                                          fontSize: "0.9rem",
                                        }}
                                      >
                                        Select Branch
                                      </span>
                                    )}

                                    {/* Selected count */}
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginLeft: "auto",
                                        gap: "0.25rem",
                                        fontSize: "0.8rem",
                                        color: "#666",
                                      }}
                                    >
                                      <ChevronDown
                                        size={16}
                                        style={{
                                          transform: isStockOpen
                                            ? "rotate(180deg)"
                                            : "rotate(0deg)",
                                          transition: "transform 0.2s",
                                          userSelect: "none",
                                        }}
                                      />
                                    </span>
                                  </div>

                                  {/* DROPDOWN PANEL (visible when isStockOpen) */}
                                  {isStockOpen && (
                                    <div
                                      className="options-container"
                                      style={{
                                        border: "1px solid #6c757d",
                                        borderRadius: "8px",
                                        marginTop: "4px",
                                        maxHeight: "270px",
                                        overflowY: "auto",
                                        background: "#fff",
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        zIndex: 1000,
                                        width: "100%",
                                        boxshadow: "0px 1px 4px 0px #0000001A",
                                      }}
                                      onWheel={(e) => e.preventDefault()}
                                    >
                                      {/* Search input with icon */}
                                      <div
                                        style={{
                                          padding: "0.5rem",
                                          position: "relative",
                                        }}
                                      >
                                        <Search
                                          size={18}
                                          style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "18px",
                                            transform: "translateY(-50%)",
                                            color: "#6C757D",
                                            pointerEvents: "none",
                                          }}
                                        />
                                        <input
                                          type="text"
                                          className="search-input select-box form-control common-input-all"
                                          placeholder="Search..."
                                          value={stockSearch}
                                          onChange={(e) =>
                                            setStockSearch(e.target.value)
                                          }
                                          style={{
                                            width: "100%",
                                            padding:
                                              "0.5rem 0.5rem 0.5rem 2rem",
                                            fontSize: "0.9rem",
                                            outline: "none",
                                          }}
                                        />
                                      </div>

                                      {/* Options list */}
                                      <ul
                                        className="options-list custom-check"
                                        style={{
                                          listStyle: "none",
                                          margin: 0,
                                          padding: "1.25rem",
                                          maxHeight: "420px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {[
                                          ...new Set([
                                            ...allStock.filter((d) =>
                                              d.label
                                                .toLowerCase()
                                                .includes(
                                                  stockSearch
                                                    .trim()
                                                    .toLowerCase()
                                                )
                                            ),
                                            ...tempSelectedStock.filter(
                                              (s) =>
                                                !allStock.some(
                                                  (d) => d.value === s.value
                                                )
                                            ),
                                          ]),
                                        ].map((d) => (
                                          <li
                                            key={d.value}
                                            style={{ marginBottom: "0.5rem" }}
                                          >
                                            <label
                                              className="option-item"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: "pointer",
                                                fontSize: "0.9rem",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={tempSelectedStock.some(
                                                  (item) =>
                                                    item.value === d.value
                                                )}
                                                onChange={() =>
                                                  handleTempStockCheckbox(d)
                                                }
                                                style={{ marginRight: "8px" }}
                                              />
                                              {d.label}
                                            </label>
                                          </li>
                                        ))}

                                        {allStock.filter((d) =>
                                          d.label
                                            .toLowerCase()
                                            .includes(
                                              stockSearch.trim().toLowerCase()
                                            )
                                        ).length === 0 &&
                                          tempSelectedStock.length === 0 && (
                                            <li
                                              style={{
                                                color: "#999",
                                                textAlign: "center",
                                                fontSize: "0.9rem",
                                              }}
                                            >
                                              No branch found
                                            </li>
                                          )}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-auto main-drawer-inner">
                            <div className="edit-organisation-info d-flex justify-content-end align-items-center gap-2 mt-auto">
                              <button
                                className="dark-button"
                                type="button"
                                onClick={() => {
                                  closeAllDropdowns();
                                  setStockfilterDrawerOpen(false);
                                  setTempSelectedStock(selectedStock); // discard any changes, keep main drawer visible
                                }}
                              >
                                Cancel
                              </button>

                              <button
                                className="dark-border"
                                type="button"
                                onClick={() => {
                                  closeAllDropdowns();
                                  setSelectedStock(tempSelectedStock); // apply the filter
                                  setStockfilterDrawerOpen(false); // close only the filter drawer
                                }}
                              >
                                Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}
            </div>

            {instancesDrawerOpen &&
              selectedRow &&
              (() => {
                // Safely compute values here
                const pendingCount =
                  selectedRow.pending?.reduce(
                    (sum, item) => sum + item.count,
                    0
                  ) || 0;
                const total = Number(selectedRow.available || 0) + pendingCount;

                return (
                  <>
                    <div className="drawer-overlay" />
                    <div className="entity-drawer" ref={drawerRef}>
                      <div className="drawer-header">
                        <div className="d-flex align-items-center gap-1">
                          <button
                            className="back-btn"
                            onClick={() => {
                              setInstancesDrawerOpen(false);
                              setDrawerOpen(true);
                            }}
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              padding: 0,
                              margin: 0,
                            }}
                          >
                            <ChevronLeft />
                          </button>
                          <h3>Stock Instance Info</h3>
                        </div>

                        <button
                          className="close-btn"
                          onClick={() => {
                            setInstancesDrawerOpen(false);
                          }}
                        >
                          <X size={24} />
                        </button>
                      </div>

                      <div className="main-drawer-inner">
                        <div className="drawer-title d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <img
                              src="https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false"
                              alt="avatar"
                              className="avatar"
                              style={{
                                width: 40,
                                height: 40,
                                marginRight: 8,
                                verticalAlign: "middle",
                              }}
                            />
                            <h2 className="pb-0">35334107 123456 2</h2>
                          </div>
                          <div className="entities-tab flex-row align-items-center gap-3">
                            <div className="toolbar">
                              <div
                                className="toolbar-right"
                                style={{ position: "relative" }}
                                ref={toolbarRef}
                              >
                                <button
                                  className="drawer-dots"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleToolbarDropdown2();
                                  }}
                                >
                                  <MoreHorizontal size={18} />
                                </button>

                                {toolbarDropdownOpen2 && (
                                  <div
                                    className="backdrop-cls"
                                    style={{
                                      position: "absolute",
                                      top: 40,
                                      right: 0,
                                      background: "white",
                                      boxShadow: "0px 1px 4px 0px #0000001A",
                                      zIndex: 1000,
                                      minWidth: 152,
                                      borderRadius: 8,
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <div className="btn-align-forall">
                                      <div className="common-for-all">
                                        <button
                                          onClick={() => {
                                            setStockoutModalOpen(true);
                                          }}
                                        >
                                          Stock Out
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="drawer-tabs">
                          <button
                            className={
                              drawerTab2 === "entity-info2" ? "active" : ""
                            }
                            onClick={() => setDrawerTab2("entity-info2")}
                          >
                            Stock Info
                          </button>
                          <button
                            className={
                              drawerTab2 === "additional-info" ? "active" : ""
                            }
                            onClick={() => setDrawerTab2("additional-info")}
                          >
                            Additional Info
                          </button>
                        </div>

                        <div className="drawer-content">
                          {drawerTab2 === "entity-info2" && (
                            <div className="tab-panel entity-info-panel">
                              <div className="field-block">
                                <div className="field-label">IMEI/Barcode</div>
                                <div className="field-value">
                                  35334107 123456 2
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Open ID</div>
                                <div className="field-value d-flex align-items-center gap-2">
                                  <span
                                    style={{
                                      color: "#2C7BE5",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                      )
                                    }
                                  >
                                    8d5815b4-38d2-405c-86c0-3366fa7cbccc
                                  </span>
                                  <Copy
                                    size={13}
                                    onClick={() =>
                                      navigator.clipboard.writeText(
                                        "8d5815b4-38d2-405c-86c0-3366fa7cbccc"
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      color: "#2C7BE5",
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Status</div>
                                <div className="field-value">
                                  <span
                                    className={`status ${selectedRow.status.toLowerCase()}`}
                                  >
                                    {selectedRow.status}
                                  </span>
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">ID</div>
                                <div className="field-value">
                                  {selectedRow.iD}
                                </div>
                              </div>
                              <div className="field-block">
                                <div className="field-label">Branch</div>
                                <div className="field-value">
                                  <a
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-flex align-items-center gap-1 me-3"
                                    style={{
                                      color: "#2C7BE5",
                                      textDecoration: "underline",
                                      fontWeight: "600",
                                      fontSize: "12px",
                                    }}
                                  >
                                    Bedok
                                    <SquareArrowOutUpRight
                                      size={14}
                                      strokeWidth={3}
                                    />
                                  </a>
                                </div>
                              </div>
                              <div className="field-block">
                                <div className="field-label">Reserved</div>
                                <div className="field-value">
                                  {selectedRow.reserved}
                                </div>
                              </div>

                              <div className="field-block">
                                <div className="field-label">Quantity</div>

                                <div
                                  className="field-value"
                                  style={{ marginBottom: "2px", gap: "4px" }}
                                >
                                  Total: {total}
                                </div>

                                <div
                                  className="field-value"
                                  style={{ marginBottom: "2px", gap: "4px" }}
                                >
                                  Available: {selectedRow.available}
                                </div>

                                <div
                                  className="field-value"
                                  style={{ gap: "4px" }}
                                >
                                  Pending: {pendingCount}
                                </div>

                                <div
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "5px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 4,
                                      maxWidth: "150px",
                                    }}
                                  >
                                    {selectedRow.pending?.map((p, i) => (
                                      <div
                                        key={i}
                                        className="field-value"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <span
                                          style={{
                                            color: p.color,
                                            fontSize: 14,
                                            marginRight: 6,
                                          }}
                                        >
                                          ●
                                        </span>
                                        <span style={{ marginRight: 4 }}>
                                          {p.type}
                                        </span>
                                        <span
                                          style={{
                                            marginLeft: "auto",
                                            marginRight: "8px",
                                          }}
                                        >
                                          {p.count}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                              <div className="field-block gy-3 gy-md-0 row">
                                <div className="col-md-6">
                                  <div className="field-label">
                                    First Stock In Time
                                  </div>
                                  <div className="field-value">
                                    2024-12-01 23:34
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="field-label">
                                    First Stock In Channel
                                  </div>
                                  <div className="field-value">Purchase</div>
                                </div>
                              </div>
                              <div className="field-block gy-3 gy-md-0 row">
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock In Time
                                  </div>
                                  <div className="field-value">
                                    2024-12-01 23:34
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock In Channel
                                  </div>
                                  <div className="field-value">Purchase</div>
                                </div>
                              </div>
                              <div className="field-block gy-3 gy-md-0 row">
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock Out Time
                                  </div>
                                  <div className="field-value">
                                    2024-12-01 23:34
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="field-label">
                                    Last Stock Out Channel
                                  </div>
                                  <div className="field-value">Purchase</div>
                                </div>
                              </div>
                            </div>
                          )}
                          {drawerTab2 === "additional-info" && (
                            <div className="tab-panel additional-info-panel">
                              <p className="note-type-added">Note</p>
                              <label className="no-description-cls notes-preserve">
                                No Description
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}

            {stockoutModalOpen && (
              <>
                {/* Overlay backdrop */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={stockoutRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  {/* Header */}
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                      className="close-btn"
                      onClick={() => setStockoutModalOpen(false)}
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <h3
                    style={{
                      textAlign: "left",
                      color: "#212529",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "24px",
                      fontFamily: "Montserrat",
                      marginBottom: "5px",
                    }}
                  >
                    Initiate Stock Out
                  </h3>
                  {/* Subtext */}
                  <p
                    style={{
                      marginBottom: "0",
                      textAlign: "left",
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    Initiating a stock-out means marking the item as no longer
                    part of active inventory. This action only applies to cases
                    such as loss, scrap, or other non-sale or gift removals.
                  </p>

                  {/* Form Content */}
                  <div className="drawer-content">
                    <div className="row gappingcls-added">
                      <div className="col-12">
                        <div className="info-inner tab-panel">
                          <div className="field-block">
                            <div
                              className="field-label"
                              style={{
                                display: "flex",
                                gap: "4px",
                                alignItems: "center",
                              }}
                            >
                              Stock Out{" "}
                              <span
                                className="error-color"
                                style={{ color: "red" }}
                              >
                                *
                              </span>
                              <Tooltip content="Choose Stock Out">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </div>
                            <select className="form-select new-form-select-cls">
                              <option value="">Select Stock Out</option>
                              <option value="Loss">Loss</option>
                              <option value="Out">Out</option>
                            </select>
                          </div>
                          <div className="field-block">
                            <div
                              className="field-label"
                              style={{
                                display: "flex",
                                gap: "4px",
                                alignItems: "center",
                              }}
                            >
                              Quantity{" "}
                              <span
                                className="error-color"
                                style={{ color: "red" }}
                              >
                                *
                              </span>
                              <Tooltip content="Choose Quantity">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </div>

                            <div className="custom-quantity-wrapper">
                              <input
                                type="number"
                                value={quantity}
                                onChange={(e) =>
                                  setQuantity(Number(e.target.value))
                                }
                                className="custom-quantity-input"
                              />
                              <div className="custom-spinner">
                                <ChevronUp
                                  size={16}
                                  onClick={handleIncrease}
                                  className="spinner-icon"
                                />
                                <ChevronDown
                                  size={16}
                                  onClick={handleDecrease}
                                  className="spinner-icon"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="field-block">
                            <div
                              className="field-label"
                              style={{
                                display: "flex",
                                gap: "4px",
                                alignItems: "center",
                              }}
                            >
                              Reason{" "}
                              <span
                                className="error-color"
                                style={{ color: "red" }}
                              >
                                *
                              </span>
                              <Tooltip content="Choose Reason">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </div>
                            <textarea
                              className="form-control w-100 common-textarea-all"
                              id="exampleFormControlTextarea1"
                              rows="3"
                              name="Reason"
                              style={{
                                borderColor: "#6c757d",
                                borderRadius: "8px",
                                resize: "none",
                                height: "120px",
                                overflowY: "auto",
                                fontFamily: '"Montserrat", sans-serif',
                                color: "#6c757d",
                                fontSize: "14px",
                                fontWeight: 400,
                                lineHeight: "18px",
                                boxShadow: "none",
                              }}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button
                      className="btn-cancel"
                      onClick={() => setStockoutModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn-save"
                      onClick={handleStockoutConfirm}
                    >
                      Stock Out
                    </button>
                  </div>
                </div>
              </>
            )}

            {archivedModalOpen && (
              <>
                {/* Overlay backdrop */}
                <div className="drawer-overlay" />

                <div
                  className="entity-drawer modal-popup-cls"
                  ref={archivedRef}
                  style={{
                    maxWidth: 650,
                    margin: "0 auto",
                    background: "white",
                    borderRadius: 12,
                    zIndex: 1050,
                    padding: 24,
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                    height: "auto",
                    right: "auto",
                    overflow: "inherit",
                  }}
                >
                  {/* Header */}
                  <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                    <button
                      className="close-btn"
                      onClick={() => setArchivedModalOpen(false)}
                    >
                      <X size={20} />
                    </button>
                  </div>

                  <h3
                    style={{
                      textAlign: "left",
                      color: "#212529",
                      fontSize: "20px",
                      fontWeight: "600",
                      lineHeight: "24px",
                      fontFamily: "Montserrat",
                      marginBottom: "5px",
                    }}
                  >
                    Branch can’t be archived
                  </h3>
                  {/* Subtext */}
                  <p
                    style={{
                      marginBottom: "0",
                      textAlign: "left",
                      color: "#6C757D",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    Branch stocked with items can’t be archived, clear stock
                    before archiving. Archive action is also subject to approval
                  </p>

                  {/* Footer */}
                  <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                    <button
                      className="btn-save"
                      onClick={handleArchivedConfirm}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>

      <style>{`
   /* Disable Search Box when table empty */
.search-box-disabled {
    border-radius: 8px !important;
    border: 1px solid #CED4DA !important;  /* Gray-400 */
    background: #F8F9FA !important;        /* Gray-100 */
    opacity: 0.6;
    pointer-events: none;                  /* disable input */
}
/* Disabled Filter Button */
.filter-disabled {
    border-radius: 8px !important;
    border: 1px solid var(--Gray-400, #CED4DA) !important;
    background: var(--Gray-100, #F8F9FA) !important;
    opacity: 0.6;
    pointer-events: none !important; /* block click */
    cursor: not-allowed !important;
}
    .cell-wrapper {
  width: 100%;
  word-break: break-all;
  cursor: text;          /* ⬅ user can select text in empty area */
}

.value-container {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.value-clickable {
  color: #2C7BE5;
  text-decoration: underline;
  cursor: url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Ctext y='24' font-size='24'%3E%E2%9C%8B%3C/text%3E%3C/svg%3E") 12 12, pointer;
}

.copy-icon {
  cursor: url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Ctext y='24' font-size='24'%3E%E2%9C%8B%3C/text%3E%3C/svg%3E") 12 12, pointer;
}

.copied-label {
  font-size: 12px;
  color: #2C7BE5;
}

.entities-table .actionHeader {
  width: 56px;
  min-width: 56px;
  max-width: 56px;
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 6;
  bax-shadow
}

.entities-table td.actionColumn {
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 10;
}

/* FAKE SHADOW INSIDE CELL */
.entities-table td.actionColumn::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 0;
  width: 8px;
  height: 100%;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.12),
    rgba(0, 0, 0, 0)
  );
  pointer-events: none;
}

.entities-table th.actionHeader::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 0;
  width: 8px;
  height: 100%;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.12),
    rgba(0, 0, 0, 0)
  );
  pointer-events: none;
}

.entities-table td.firstColumn {
  max-width:200px !important;
}

.entities-table th:nth-child(2){
  position: sticky;
  left: 200px !important;
  z-index: 3;
}

.entities-table td:nth-child(2) {
  position: sticky !important;
  left: 200px !important;
  z-index: 3;
  background: inherit !important;
}

.entities-table th:nth-child(3){
  position: sticky;
  left: 320px !important;
  z-index: 3;
}

.entities-table td:nth-child(3) {
  position: sticky !important;
  left: 320px !important;
  z-index: 3;
  background: inherit !important;
}

.entities-table th:nth-child(3)::after,
.entities-table td:nth-child(3)::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.12),
    rgba(0, 0, 0, 0)
  );
  z-index: 1;
}
.highlight{
    display: inline-block;
    padding: 3px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    font-family: "Montserrat", sans-serif;
    min-width: 110px;
    text-align: center;
    background:#FFEB00;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
}

td:has(.no-ellipsis) {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

.drawer-title{
border:none;
}

.drawer-tabs{
  margin-top:-30px;
  border:none !important;
}

.stock-wrapper .entities-table thead th:nth-child(9) svg {
  display: none !important;
  pointer-events: none;
}



.stock-wrapper .entities-table thead th:nth-child(8) span > span[style*="flex-direction: column"] {
  display: none !important;
}
   `}</style>
    </div>
  );
}
